'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React$1 = require('react');
var styled = require('styled-components');
var kebabCase = require('kebab-case');
var useBreakpoint = require('use-breakpoint');
var marked = require('marked');
var dateFns = require('date-fns');
var reactShare = require('react-share');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React$1);
var React__namespace = /*#__PURE__*/_interopNamespace(React$1);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var kebabCase__default = /*#__PURE__*/_interopDefaultLegacy(kebabCase);
var useBreakpoint__default = /*#__PURE__*/_interopDefaultLegacy(useBreakpoint);
var marked__default = /*#__PURE__*/_interopDefaultLegacy(marked);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _templateObject$17;
var Box = styled__default["default"].div(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.mt ? "margin-top: ".concat(props.mt, ";") : '';
}, function (props) {
  return props.mb ? "margin-bottom: ".concat(props.mb, ";") : '';
}, function (props) {
  return props.ml ? "margin-left: ".concat(props.ml, ";") : '';
}, function (props) {
  return props.mr ? "margin-right: ".concat(props.mr, ";") : '';
}, function (props) {
  return props.margin ? "margin: ".concat(props.margin, ";") : '';
}, function (props) {
  return props.pt ? "padding-top: ".concat(props.pt, ";") : '';
}, function (props) {
  return props.pb ? "padding-bottom: ".concat(props.pb, ";") : '';
}, function (props) {
  return props.pl ? "padding-left: ".concat(props.pl, ";") : '';
}, function (props) {
  return props.pr ? "padding-right: ".concat(props.pr, ";") : '';
}, function (props) {
  return props.padding ? "padding: ".concat(props.padding, ";") : '';
}, function (props) {
  return props.w ? "width: ".concat(props.w, ";") : '';
}, function (props) {
  return props.minWidth ? "min-width: ".concat(props.minWidth, ";") : '';
}, function (props) {
  return props.maxWidth ? "max-width: ".concat(props.maxWidth, ";") : '';
}, function (props) {
  return props.h ? "height: ".concat(props.h, ";") : '';
}, function (props) {
  return props.minHeight ? "min-height: ".concat(props.minHeight, ";") : '';
}, function (props) {
  return props.maxHeight ? "max-height: ".concat(props.maxHeight, ";") : '';
}, function (props) {
  return props.backgroundColor ? "background-color: ".concat(props.backgroundColor, ";") : '';
}, function (props) {
  return props.right ? 'text-align: right;' : '';
}, function (props) {
  return props.center ? 'text-align: center;' : '';
});

var _templateObject$16;
var FlexBox = styled__default["default"](Box)(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteral(["\n  display: flex;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.justifyContent ? "justify-content: ".concat(props.justifyContent, ";") : '';
}, function (props) {
  return props.alignItems ? "align-items: ".concat(props.alignItems, ";") : '';
}, function (props) {
  return props.flexDirection ? "flex-direction: ".concat(props.flexDirection, ";") : '';
}, function (props) {
  return props.flexWrap ? "flex-wrap: ".concat(props.flexWrap, ";") : '';
}, function (props) {
  return props.alignSelf ? "align-self: ".concat(props.alignSelf, ";") : '';
}, function (props) {
  return props.textAlign ? "text-align: ".concat(props.textAlign, ";") : '';
});

var white = '#FFF';
var black = '#000';
var grey100 = '#151617';
var grey200 = '#2D2F30';
var grey300 = '#4F4F4F';
var grey400 = '#727272';
var grey500 = '#CBCED0';
var grey600 = '#EAEAEA';
var grey700 = '#F1F1F2';
var grey800 = '#F9F8F9';
var red = '#DF3045';
var darkTeal = '#004354';
var teal = '#13ACBF';
var green = '#AEC347';
var limeGreen = '#DAE7B8';
var purple = '#541E57';
var magenta = '#E8B2D2';

var _templateObject$15;
var H1 = styled__default["default"].h1(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteral(["\n  font-family: roc-grotesk-compressed;\n  font-weight: ", ";\n  color: ", ";\n  text-transform: uppercase;\n\n  @media (min-width: 1025px) {\n    font-size: 130px;\n    line-height: 110px;\n  }\n\n  @media (max-width: 1024px) {\n    font-size: 100px;\n    line-height: 84px;\n  }\n\n  @media (max-width: 768px) {\n    font-size: 60px;\n    line-height: 56px;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", ";  \n"])), function (props) {
  return props.light ? 300 : 600;
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.shadow ? props.dark ? "text-shadow: .1px  .1px .2px hsla(0,0%,15%,.35), -.1px -.1px .2px hsla(0,0%,15%,.25)" : "text-shadow: 1px 1px 2px black, 0 0 1.5em gray;" : '';
}, function (props) {
  return props.margin ? "margin: ".concat(props.margin, ";") : '';
}, function (props) {
  return props.right ? 'text-align: right;' : '';
}, function (props) {
  return props.textTransform ? "text-transform: ".concat(props.textTransform) : '';
});

var _templateObject$14;
var H2 = styled__default["default"].h2(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteral(["\n  font-family: roc-grotesk-condensed;\n  font-weight: ", ";\n  color: ", ";\n  text-transform: uppercase;\n\n  @media (min-width: 1025px) {\n    font-size: 70px;\n    line-height: 65px;\n  }\n\n  @media (max-width: 1024px) {\n    font-size: 55px;\n    line-height: 50px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 36px;\n    line-height: 40px;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", ";\n"])), function (props) {
  return props.light ? 300 : 600;
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.shadow ? props.dark ? "text-shadow: .1px  .1px .2px hsla(0,0%,15%,.35), -.1px -.1px .2px hsla(0,0%,15%,.25)" : "text-shadow: 1px 1px 2px black, 0 0 1.5em gray;" : '';
}, function (props) {
  return props.margin ? "margin: ".concat(props.margin, ";") : '';
}, function (props) {
  return props.right ? 'text-align: right;' : '';
}, function (props) {
  return props.textTransform ? "text-transform: ".concat(props.textTransform) : '';
});

var _templateObject$13;
var H3 = styled__default["default"].h3(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-transform: ", ";\n\n  @media (min-width: 1025px) {\n    font-size: 48px;\n    line-height: 62px;\n  }\n\n  @media (max-width: 1024px) {\n    font-size: 40px;\n    line-height: 52px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 32px;\n    line-height: 44px;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", ";\n"])), function (props) {
  return props.variant === 'condensed' ? 'roc-grotesk-condensed' : 'usual';
}, function (props) {
  return props.light ? 300 : 600;
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.uppercase ? 'uppercase' : '';
}, function (props) {
  return props.shadow ? props.dark ? "text-shadow: .1px  .1px .2px hsla(0,0%,15%,.35), -.1px -.1px .2px hsla(0,0%,15%,.25)" : "text-shadow: 1px 1px 2px black, 0 0 1.5em gray;" : '';
}, function (props) {
  return props.margin ? "margin: ".concat(props.margin, ";") : '10px 0';
}, function (props) {
  return props.right ? 'text-align: right;' : '';
}, function (props) {
  return props.textTransform ? "text-transform: ".concat(props.textTransform) : '';
});

var _templateObject$12;
var H4 = styled__default["default"].h4(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-weight: ", ";\n  color: ", ";\n  text-transform: ", ";\n  \n  @media (min-width: 1025px) {\n    font-size: 32px;\n    line-height: 40px;\n  }\n\n  @media (max-width: 1024px) {\n    font-size: 28px;\n    line-height: 32px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 24px;\n    line-height: 28px;\n  }\n\n  ", "\n  ", "\n  ", "\n  ", ";\n"])), function (props) {
  return props.variant === 'condensed' ? 'roc-grotesk-condensed' : 'usual';
}, function (props) {
  return props.light ? 300 : 600;
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.uppercase ? 'uppercase' : '';
}, function (props) {
  return props.shadow ? props.dark ? "text-shadow: .1px  .1px .2px hsla(0,0%,15%,.35), -.1px -.1px .2px hsla(0,0%,15%,.25)" : "text-shadow: 1px 1px 2px black, 0 0 1.5em gray;" : '';
}, function (props) {
  return props.margin ? "margin: ".concat(props.margin, ";") : '';
}, function (props) {
  return props.right ? 'text-align: right;' : '';
}, function (props) {
  return props.textTransform ? "text-transform: ".concat(props.textTransform) : '';
});

var _templateObject$11;
var H5 = styled__default["default"].h5(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteral(["\n  font-family: usual;\n  font-weight: ", ";\n  color: ", ";\n  text-transform: ", ";\n  \n  @media (min-width: 1025px) {\n    font-size: 24px;\n    line-height: 32px;\n  }\n\n  @media (max-width: 1024px) {\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.light ? 300 : 600;
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.uppercase ? 'uppercase' : '';
}, function (props) {
  return props.shadow ? props.dark ? "text-shadow: .1px  .1px .2px hsla(0,0%,15%,.35), -.1px -.1px .2px hsla(0,0%,15%,.25)" : "text-shadow: 1px 1px 2px black, 0 0 1.5em gray;" : '';
}, function (props) {
  return props.margin ? "margin: ".concat(props.margin, ";") : '';
}, function (props) {
  return props.right ? 'text-align: right;' : '';
});

var _templateObject$10;
var H6 = styled__default["default"].h6(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  font-weight: ", ";\n  text-transform: ", ";\n  \n  font-size: ", ";\n  line-height: ", ";\n  margin: ", ";\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.variant === 'condensed' ? 'roc-grotesk-condensed' : 'usual';
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.light ? 300 : 600;
}, function (props) {
  return props.uppercase ? 'uppercase' : '';
}, function (props) {
  return props.variant === 'condensed' ? '18px' : '14px';
}, function (props) {
  return props.variant === 'condensed' ? '24px' : '18px';
}, function (props) {
  return props.margin || '5px 0';
}, function (props) {
  return props.right ? 'text-align: right;' : '';
}, function (props) {
  return props.center ? 'text-align: center;' : '';
}, function (props) {
  return props.shadow ? props.dark ? "text-shadow: .1px  .1px .2px hsla(0,0%,15%,.35), -.1px -.1px .2px hsla(0,0%,15%,.25)" : "text-shadow: 1px 1px 2px black, 0 0 1.5em gray;" : '';
});

var _templateObject$$;
var Body = styled__default["default"].div(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteral(["\n  font-family: usual;\n  font-weight: ", ";\n  color: ", ";\n  font-style: ", ";\n\n  font-size: ", ";\n  \n  line-height: ", ";\n\n  ", "\n"])), function (props) {
  return props.bold ? '600' : '200';
}, function (props) {
  return props.dark ? 'white' : props.color || 'black';
}, function (props) {
  return props.italic ? 'italic' : '';
}, function (props) {
  switch (props.variant) {
    case 'large':
      return '18px';
    case 'small':
      return '14px';
    case 'tiny':
      return '12px';
    default:
      return '16px';
  }
}, function (props) {
  switch (props.variant) {
    case 'large':
      return '28px';
    case 'small':
      return '22px';
    case 'tiny':
      return '19px';
    default:
      return '25px';
  }
}, function (props) {
  return props.textAlign ? "text-align: ".concat(props.textAlign, ";") : '';
});

var _templateObject$_;
var Caption = styled__default["default"].div(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteral(["\n  font-family: usual;\n  font-weight: ", ";\n  ", "\n  color: ", ";\n  font-size: 12px;\n  line-height: 22px;\n  ", "\n  ", "\n"])), function (props) {
  return props.bold ? '600' : '200';
}, function (props) {
  return props.italic ? 'font-style: italic;' : '';
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.right ? 'text-align: right;' : '';
}, function (props) {
  return props.center ? 'text-align: center;' : '';
});

var Alert = (function (_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    h: "50px",
    w: "100%",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: purple,
    textAlign: "center"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    mr: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    color: white,
    variant: "small"
  }, message)));
});

var _templateObject$Z;
var Container$D = styled__default["default"](Box)(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteral(["\n padding: 0 40px 64px 40px;\n background-image: url(/journeyline-article-quote.svg);\n background-repeat: no-repeat;\n background-position: bottom left;\n height: auto;\n max-width: 600px;\n"])));
var ArticleQuote = (function (_ref) {
  var quote = _ref.quote,
    attribution = _ref.attribution;
  return /*#__PURE__*/React__default["default"].createElement(Container$D, null, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(Box, {
    mb: "15px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "large",
    color: teal,
    italic: true
  }, "\"".concat(quote, "\""))), /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "large",
    color: grey400
  }, "- ".concat(attribution))));
});

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 45,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.342 20.029 1-1v-6.267l-1-1H16.545V1.008L14.842.297.297 14.67l.703.712-.703.71 14.431 14.27 1.703-.712V18.04h-2v9.215L2.423 15.381 14.545 3.402v9.36l1 1h26.797v4.267H20.756v2h22.586Z",
    fill: props.color
  }));
};

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 45,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M23.863 11.621H1.277v6.267h27.797v11.754L43.619 15.27 29.187 1v11.61",
    stroke: props.color,
    strokeWidth: 2,
    strokeLinejoin: "bevel"
  }));
};

var SvgBag = function SvgBag(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 45,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.25 12.61v-2.29a9.13 9.13 0 1 1 18.26 0v5h6.63l4.78 28.47H1.14l4.78-28.44h21.22",
    stroke: props.color,
    strokeWidth: 2.38,
    strokeLinejoin: "bevel"
  }));
};

var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 6,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    stroke: props.color,
    d: "m1.16481,8.39641l0,2.5916l3.90796,-3.70228l-3.90796,-3.70228l0,2.5916",
    strokeWidth: "1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var Close = (function (_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__namespace.createElement("svg", {
    width: 28,
    height: 28,
    x: "0px",
    y: "0px",
    version: "1.1",
    id: "Layer_1",
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: 'new 0 0 32 30'
    }
  }, /*#__PURE__*/React__namespace.createElement("line", {
    fill: "none",
    stroke: color,
    strokeWidth: "2px",
    x1: "2",
    y1: "28",
    x2: "28",
    y2: "2"
  }), /*#__PURE__*/React__namespace.createElement("line", {
    fill: "none",
    stroke: color,
    strokeWidth: "2px",
    x1: "2",
    y1: "2",
    x2: "15",
    y2: "15"
  }), /*#__PURE__*/React__namespace.createElement("line", {
    fill: "none",
    stroke: color,
    strokeWidth: "2px",
    x1: "17",
    y1: "17",
    x2: "28",
    y2: "28"
  }));
});

var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 24,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.037 12 2 2h7.377M14.707 2.078H22l-9.963 9.921",
    stroke: props.color,
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#clip0_1872_9678)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.5203 42.8144L1.20834 28.5024L12.9123 28.5024L12.9123 9.15039L19.1523 9.15039L19.1523 23.3744",
    stroke: "#DF3045",
    strokeWidth: "2.7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.1685 28.6152L29.7285 28.6152L15.5205 42.8152",
    stroke: "#DF3045",
    strokeWidth: "2.7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React__namespace.createElement("line", {
    x1: "1.35",
    y1: "43.65",
    x2: "30.65",
    y2: "43.65",
    stroke: "#DF3045",
    strokeWidth: "2.7",
    strokeLinecap: "round"
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "clip0_1872_9678"
  }, /*#__PURE__*/React__namespace.createElement("rect", {
    width: "43.296",
    height: "29.872",
    fill: "white",
    transform: "translate(30.4004 0.199219) rotate(90)"
  }))));
};

var SvgElevator = function SvgElevator(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 28,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#elevator_svg__a)",
    stroke: props.color,
    strokeWidth: 2.38,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m5.92 55.84 7.89 7.89 7.83-7.83M21.64 8.73 13.75.84 5.92 8.68M13.78 24.39a2.67 2.67 0 1 1 0-5.34 2.67 2.67 0 0 1 0 5.34Z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.02 38.86h2.95V27.23H8.9v11.63h2.72v11.5H1.19V14.21h25.17v36.15h-9.98"
  })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "elevator_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h27.56v64.58H0z"
  }))));
};

var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.008.637a.735.735 0 0 1 .722.445c.127.29.067.63-.15.855L8.005 5.63a.72.72 0 0 1-1.043 0 .78.78 0 0 1 0-1.078l2.182-2.255-6.533.464-.452 6.824 2.224-2.299a.72.72 0 0 1 1.043 0 .78.78 0 0 1 0 1.078L1.81 12.102a.72.72 0 0 1-.827.155.766.766 0 0 1-.43-.746l.63-9.516a.75.75 0 0 1 .71-.71l9.115-.648Zm5.778.013a.75.75 0 0 0-.582 1.278l3.694 3.695a.75.75 0 1 0 1.061-1.061l-2.278-2.278 6.795.467.47 6.867-2.322-2.322a.75.75 0 0 0-1.06 1.06l3.737 3.738a.75.75 0 0 0 1.278-.582l-.651-9.516a.75.75 0 0 0-.722-.699L16.786.65Zm10.18 25.556a.75.75 0 0 1-.698.722l-9.517.651a.75.75 0 0 1-.581-1.278l3.737-3.737a.75.75 0 1 1 1.06 1.06l-2.321 2.322 6.867-.47.467-6.795-2.278 2.278a.75.75 0 0 1-1.061-1.06l3.694-3.695a.75.75 0 0 1 1.279.582l-.648 9.42Zm-25.82 0a.751.751 0 0 0 .687.734l9.208.652a.735.735 0 0 0 .722-.445.781.781 0 0 0-.15-.855l-3.616-3.737a.72.72 0 0 0-1.043 0 .78.78 0 0 0 0 1.078l2.224 2.299-6.602-.468-.45-6.752 2.183 2.256a.72.72 0 0 0 1.043 0 .78.78 0 0 0 0-1.078l-3.575-3.695a.72.72 0 0 0-.827-.154.766.766 0 0 0-.43.746l.627 9.42Z",
    fill: props.color
  }));
};

// 35x35 svg ICONS FROM https://icons8.com/icon/set/social-media/material-outlined

var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "35",
    height: "35",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M 5 3 C 3.897 3 3 3.897 3 5 L 3 19 C 3 20.103 3.897 21 5 21 L 11.621094 21 L 14.414062 21 L 19 21 C 20.103 21 21 20.103 21 19 L 21 5 C 21 3.897 20.103 3 19 3 L 5 3 z M 5 5 L 19 5 L 19.001953 19 L 14.414062 19 L 14.414062 15.035156 L 16.779297 15.035156 L 17.130859 12.310547 L 14.429688 12.310547 L 14.429688 10.574219 C 14.429687 9.7862188 14.649297 9.2539062 15.779297 9.2539062 L 17.207031 9.2539062 L 17.207031 6.8222656 C 16.512031 6.7512656 15.814234 6.71675 15.115234 6.71875 C 13.041234 6.71875 11.621094 7.9845938 11.621094 10.308594 L 11.621094 12.314453 L 9.2773438 12.314453 L 9.2773438 15.039062 L 11.621094 15.039062 L 11.621094 19 L 5 19 L 5 5 z",
    fill: props.color || grey400
  }));
};

var SvgFaucet = function SvgFaucet(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 50,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#faucet_svg__a)",
    stroke: props.color,
    strokeWidth: 2.38,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m2.01 34.2 1.43-8.73h6.27l1.43 8.73M17.92 1.14l23.79 7.59 6.76 27.72H28.51V25.97l-14.34-5.61H1.19v-6.57H32.3"
  })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "faucet_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h49.63v37.64H0z"
  }))));
};

// 35x35 svg ICONS FROM https://icons8.com/icon/set/social-media/material-outlined

var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "35",
    height: "35",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M 8 3 C 5.243 3 3 5.243 3 8 L 3 16 C 3 18.757 5.243 21 8 21 L 16 21 C 18.757 21 21 18.757 21 16 L 21 8 C 21 5.243 18.757 3 16 3 L 8 3 z M 8 5 L 16 5 C 17.654 5 19 6.346 19 8 L 19 16 C 19 17.654 17.654 19 16 19 L 8 19 C 6.346 19 5 17.654 5 16 L 5 8 C 5 6.346 6.346 5 8 5 z M 17 6 A 1 1 0 0 0 16 7 A 1 1 0 0 0 17 8 A 1 1 0 0 0 18 7 A 1 1 0 0 0 17 6 z M 12 7 C 9.243 7 7 9.243 7 12 C 7 14.757 9.243 17 12 17 C 14.757 17 17 14.757 17 12 C 17 9.243 14.757 7 12 7 z M 12 9 C 13.654 9 15 10.346 15 12 C 15 13.654 13.654 15 12 15 C 10.346 15 9 13.654 9 12 C 9 10.346 10.346 9 12 9 z",
    fill: props.color || grey400
  }));
};

var Hamburger = (function (_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    height: "32px",
    id: "Layer_1",
    version: "1.1",
    viewBox: "0 0 32 32",
    width: "32px"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    fill: color || '#fff',
    d: "M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
  }));
});

var SvgHanger = function SvgHanger(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 58,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#hanger_svg__a)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.29 7.67a6.47 6.47 0 1 1 6.47 6.47v4.17l28 14.25H.56l23.81-14",
    stroke: props.color,
    strokeWidth: 2.38,
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "hanger_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h57.35v33.75H0z"
  }))));
};

var SvgHeadingQuoteRightMobile = function SvgHeadingQuoteRightMobile(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 113,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M41 10 10 41V0",
    stroke: "#DF3045",
    strokeWidth: 15
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M17.5 22.5V0h23l-23 22.5Z",
    fill: "#fff"
  }));
};

var SvgHeadingQuoteRight = function SvgHeadingQuoteRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 113,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M113 10H43L10 41V0",
    stroke: "#DF3045",
    strokeWidth: 20
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19 18v1V0h19L19 18Z",
    fill: "#fff"
  }));
};

var SvgHide = function SvgHide(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", {
    width: "20",
    height: "12",
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.5067 0.50382C19.8356 0.839698 20 1.26718 20 1.78626C20 2.30535 19.8356 2.73283 19.5067 3.0687L11.2556 11.4962C11.0762 11.6794 10.8819 11.8095 10.6726 11.8864C10.4634 11.9621 10.2392 12 10 12C9.76084 12 9.52885 11.9542 9.30404 11.8626C9.08042 11.771 8.89387 11.6489 8.74439 11.4962L0.493275 3.0687C0.164426 2.73282 -8.52375e-07 2.30534 -8.06995e-07 1.78626C-7.61615e-07 1.26718 0.164427 0.839696 0.493276 0.503818C0.822125 0.16794 1.24066 4.60319e-07 1.74888 5.04749e-07C2.2571 5.49179e-07 2.67564 0.167941 3.00449 0.503818L10 7.64885L16.9955 0.50382C17.3244 0.167942 17.7429 1.90299e-06 18.2511 1.94742e-06C18.7593 1.99185e-06 19.1779 0.167942 19.5067 0.50382V0.50382Z",
    fill: "white"
  }));
};

var SvgIiif = function SvgIiif(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 40,
    height: 38,
    fill: "none",
    viewBox: "0 0 40 38",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#clip0_1967_8884)"
  }, /*#__PURE__*/React__namespace.createElement("rect", {
    x: "-4",
    y: "-2",
    width: "48",
    height: "42",
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    href: "#image0_1967_8884",
    transform: "translate(0.113636 0.105263) scale(0.0227273 0.0263158)"
  })), /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "clip0_1967_8884"
  }, /*#__PURE__*/React__namespace.createElement("rect", {
    width: "40",
    height: "38",
    fill: "white"
  })), /*#__PURE__*/React__namespace.createElement("image", {
    id: "image0_1967_8884",
    width: "34",
    height: "30",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAEiElEQVRYCcWXPXLbSBCFfQSHDh2uCWjNTMSArmK2qbINrRuYIsiyM+kGOgLKALVbtYmOwCPwAgviCDwCXK+730wDlOzQqpJmqEL3fP36B8M3b37jTx/CbReun09lcf4tGP1yuerKoj+VxdCVxYBVQPJtvcqqps+rZsiqff/ntn2Yr+u3U8p+NX/bLcNDb05Ooej7EOZ47mq7f8w2zZBv2yGv2mf4nNrjcx8WtwTowmI4hRFIe4aTbNMO4qxq4OzoYQBxKotj76Loy4BozrPd0zyvAKA+sOLz1aa59TD/fypuAIFf+OGKvTwnhtu9GKtDc3rXHOioC9dH0ENKGHpHiJ6HK4yCCEz1zx/0QSURAFNCMAVROScgInGMyh9MY64JJAGkgNovOAQpER+WCtpiRYoUpNofNLdwpL8xTbv2GQ/BgDB0gs99WRxmu//e5RUVNR8SXDPMNu39bFe/k+4IYzXF5zJ8RdpNkXqlNcJiS0B5tZf08HC/SpqsWFGggJeADEJU2bb382//vkctMa0CIEEEVUIo7A8KSxyJIoyuHbL1vqYiHkKchUUsRhQ2CpyKcp1tnu6hGG2RBijJGvEMca+5Ts7Q0ojGQKTv4RCFi1kQDW0DGLR+XjVngnz82vxl9tIlBLK0vqDI7qlGG8IIDrn3h2FmMJ+yL0ONIsQzedUcoCpbHvbc/wzkAkirvBmyu6bPMdBMiRHIavG+L4r1yQaaOFmGBwOJXZetm/rDur0Z2ZZBi10KVuZPLH74ic9SSl11jiBKAp2K4pBkVUdSfAbiBmHsPKTow2a/wCE4jPasD6qB+eRAdG4QSB1LF0gt0AlWDCQ4kcJbLk0RtY92HAN33z8rSFKBAASCTwdirRuHG8Y1/qfvDAGZDCNx6BTR51NAMouqBBIDcOowIAfCdPj3zQTEOaBCeAnCSUppAsFMyQxkGggARkqQJDniMDOHpggNCcA1gTAQ2Ot+rIge7NOBPc+Pq4D4iWg59qmRVOgbVwYSHCWQ6VQ2mJgaHe8e5CeKqBpacKaMKSKHWqHCgdwl8Jmpkbd3UiOq4lPjUkugqAQ3ODwVm0FAFV+sAHAwAkQQKshuQaHLRUuLFeCEZ1pfUSQVaYRCrj0I7iO4VQmM5fwFkKTopFhp57qPQsQVUiqAL7pLRdhuvOL5GtGXJl6YpgZUdjXilXg1NZddY8XnFbGI5IrIuwUVQaviGiAQUFKBEogOtBEML0RRDjcH1Jlz+M0NNCs238pURNPh7AQsKUIFmFattVfal84II58niowieqF91QeL/bJGYO+hvBiy5+FRWnaBgXgVdJ6MixUADERbV9XJ7F0zAkCx2kX8AoR9z0KLd9hfgMQ5wtqQTrMro2tfpsQriv0lyLY96+Epz6LSJDXMrTk8p4tRe2RauCIoFusUgJ8vQHgrk29piI7j3oEwt10onuXrAW/f5g23sqtt8yjfGiddwwAkxQEX6etHfku8gOE/cBnKNs1aLsMG0pXFsSuLdb9ayB2Wz762XlXtTVY1db75/jeeAUCHq+WnYnRzo/0P2/FVSHgsMrAAAAAASUVORK5CYII="
  })));
};

var SvgJourneylinePrimaryDown = function SvgJourneylinePrimaryDown(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 1378,
    height: 182,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M-4 10h1372v172",
    stroke: props.color || red,
    strokeWidth: 20
  }));
};

var SvgJourneylinePrimaryUp = function SvgJourneylinePrimaryUp(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 1335,
    height: 323,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M1340 313H10V0",
    stroke: "#DF3045",
    strokeWidth: 20
  }));
};

var SvgLeft = function SvgLeft(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 25,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    stroke: props.color,
    d: "m20.40716,24.7443l0,11.07003l-15.81433,-15.81433l15.81433,-15.81433l0,11.07003",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m21.296 20.182-5.948-5.948a8.679 8.679 0 1 0-1.114 1.114l5.948 5.948 1.114-1.114ZM1.604 8.692a7.09 7.09 0 1 1 7.089 7.09 7.097 7.097 0 0 1-7.09-7.09Z",
    fill: props.color
  }));
};

var SvgMask = function SvgMask(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 66,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#mask_svg__a)",
    stroke: props.color,
    strokeWidth: 2.38,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M10.18 9.19H1.15l4.77 17.63h4.26M55.81 9.19h9.03l-4.77 17.63h-4.26M21.51 21.77h22.34M35.98 1.58l16.38 7.61V26.5l-19.84 8.67-19.05-8.99V9.19L32.52 1.1v16.49"
  })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "mask_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h65.99v36.26H0z"
  }))));
};

var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__default["default"].createElement("path", {
    stroke: props.color || grey400,
    strokeWidth: 2,
    d: "M1 1h33v33H1z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.368 21.12c-.43 2.408-.952 4.717-2.508 5.925-.479-3.64.705-6.377 1.254-9.28-.936-1.687.113-5.085 2.09-4.247 2.433 1.03-2.106 6.275.942 6.93 3.18.686 4.481-5.904 2.507-8.05-2.85-3.094-8.3-.07-7.629 4.361.163 1.085 1.21 1.412.418 2.907-1.825-.433-2.369-1.973-2.3-4.025.113-3.36 2.822-5.71 5.54-6.037 3.437-.412 6.661 1.35 7.107 4.808.5 3.903-1.551 8.13-5.227 7.826-.993-.082-1.414-.613-2.194-1.12v.002Z",
    fill: props.color || grey400
  }));
};

var SvgPointFilled = function SvgPointFilled(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0 14V0h16L0 14Z",
    fill: props.color
  }));
};

var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 35,
    height: 36,
    fill: "none",
    viewBox: "0 0 35 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.352 9.058V.957H5.648v8.101a5.788 5.788 0 0 0-5.492 5.774v13.875H5.07v-2.313H2.47V14.833a3.473 3.473 0 0 1 3.469-3.469h23.125a3.472 3.472 0 0 1 3.468 3.469v11.563h-3.18v2.312h5.493V14.832a5.789 5.789 0 0 0-5.492-5.774Zm-2.313-.007H7.961V3.27h19.078v5.78Zm.578 5.203h2.313v2.312h-2.313v-2.312ZM4.492 21.19V18.88H29.93v2.312h-2.89v14.454H7.382V21.19h-2.89Zm5.203 12.141h15.032v-12.14H9.695v12.14Z",
    fill: props.color
  }));
};

var SvgQuotePoint = function SvgQuotePoint(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M2 1.913v-1H0v1h2Zm-1 10H0v2.136l1.64-1.367-.64-.768Zm12.64-9.231a1 1 0 1 0-1.28-1.537l1.28 1.537ZM0 1.913v10h2v-10H0Zm1.64 10.769 12-10-1.28-1.537-12 10 1.28 1.537Z",
    fill: props.color
  }));
};

var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 25,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    stroke: props.color,
    d: "m3.9818,24.84194l0,11.29784l17.03639,-16.13978l-17.03639,-16.13978l0,11.29784",
    strokeWidth: "3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 40,
    height: 35,
    fill: "none",
    viewBox: "0 0 40 35",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("mask", {
    id: "share_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.176,
    width: 40,
    height: 35,
    fill: "#000"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 .176h40v35H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.192 2.728c.03.004.067.015.115.056l13.063 11.28a.231.231 0 0 1 0 .349l-13.063 11.28a.205.205 0 0 1-.115.056.258.258 0 0 1-.134-.023.24.24 0 0 1-.1-.08.21.21 0 0 1-.032-.127s-.048-7.33 0-8.075c-.824-.419-1.573 0-1.573 0l-.414.007v1.551l.436-.007v6.524c0 1.537 1.803 2.335 2.945 1.349l13.063-11.282a1.782 1.782 0 0 0 0-2.696L25.32 1.61c-1.143-.987-2.945-.186-2.945 1.348V8.9C10.453 9.036 1 11.425 1 22.723c0 4.56 2.938 9.078 6.185 11.44 1.013.737 2.457-.188 2.084-1.383-2.998-9.586.61-12.9 9.568-13.628v-1.556c-1.521.12-2.92.31-4.181.596-2.175.492-4.06 1.288-5.463 2.58-2.823 2.601-3.109 6.57-1.629 11.725-2.715-2.225-5.013-6.057-5.013-9.774 0-2.605.543-4.587 1.448-6.118C4.9 15.08 6.222 13.902 7.939 13c3.504-1.843 8.525-2.48 14.454-2.549l1.533-.017V2.958c0-.07.018-.105.032-.126a.241.241 0 0 1 .1-.08.256.256 0 0 1 .134-.024Z"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.192 2.728c.03.004.067.015.115.056l13.063 11.28a.231.231 0 0 1 0 .349l-13.063 11.28a.205.205 0 0 1-.115.056.258.258 0 0 1-.134-.023.24.24 0 0 1-.1-.08.21.21 0 0 1-.032-.127s-.048-7.33 0-8.075c-.824-.419-1.573 0-1.573 0l-.414.007v1.551l.436-.007v6.524c0 1.537 1.803 2.335 2.945 1.349l13.063-11.282a1.782 1.782 0 0 0 0-2.696L25.32 1.61c-1.143-.987-2.945-.186-2.945 1.348V8.9C10.453 9.036 1 11.425 1 22.723c0 4.56 2.938 9.078 6.185 11.44 1.013.737 2.457-.188 2.084-1.383-2.998-9.586.61-12.9 9.568-13.628v-1.556c-1.521.12-2.92.31-4.181.596-2.175.492-4.06 1.288-5.463 2.58-2.823 2.601-3.109 6.57-1.629 11.725-2.715-2.225-5.013-6.057-5.013-9.774 0-2.605.543-4.587 1.448-6.118C4.9 15.08 6.222 13.902 7.939 13c3.504-1.843 8.525-2.48 14.454-2.549l1.533-.017V2.958c0-.07.018-.105.032-.126a.241.241 0 0 1 .1-.08.256.256 0 0 1 .134-.024Z",
    fill: props.color
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m24.192 2.728.048-.397-.048.397Zm.115.056-.262.303.262-.303Zm13.063 11.28.261-.303-.261.303Zm0 .349.26.302h.001l-.261-.302Zm-13.063 11.28-.262-.302.262.303Zm-.115.056-.048-.397.048.397Zm-.134-.023.165-.364-.165.364Zm-.1-.08-.33.225.33-.225Zm-.032-.127h.4v-.002l-.4.003Zm0-8.075.4.026.016-.264-.235-.119-.181.357Zm-1.573 0 .005.4.101-.002.089-.049-.195-.35Zm-.414.007-.008-.4-.392.008v.392h.4Zm0 1.551h-.4v.409l.408-.009-.008-.4Zm.436-.007h.4v-.406l-.406.006.006.4Zm2.945 7.873-.26-.303.26.303Zm13.063-11.282.262.303-.262-.303Zm0-2.696.262-.303-.262.303ZM25.32 1.61l-.26.303.26-.303ZM22.375 8.9l.005.4.395-.005V8.9h-.4ZM7.185 34.163l.235-.324-.235.324Zm2.084-1.383-.382.12.382-.12Zm9.568-13.628.032.399.368-.03v-.369h-.4Zm0-1.556h.4v-.432l-.431.034.03.398Zm-4.181.596.088.39-.088-.39Zm-5.463 2.58-.271-.294.27.295ZM7.564 32.498l-.253.31.992.812-.354-1.233-.385.11ZM4 16.605l.344.204-.344-.204ZM7.939 13l.186.354-.186-.354Zm14.454-2.549.004.4-.004-.4Zm1.533-.017.005.4.395-.005v-.395h-.4Zm.032-7.6.331.224-.33-.225Zm.1-.082-.164-.364.165.364Zm.086.374a.226.226 0 0 1-.062-.017.155.155 0 0 1-.037-.021l.523-.606a.604.604 0 0 0-.328-.15l-.096.794Zm-.099-.038 13.063 11.28.523-.606-13.063-11.28-.523.606Zm13.063 11.28a.17.17 0 0 1 0-.257l.523.605a.63.63 0 0 0 0-.954l-.523.606Zm0-.257L24.045 25.39l.523.606 13.063-11.282-.523-.605ZM24.045 25.39a.152.152 0 0 1 .037-.022.225.225 0 0 1 .062-.017l.096.794a.604.604 0 0 0 .328-.15l-.523-.605Zm.1-.039a.176.176 0 0 1 .047 0 .122.122 0 0 1 .031.01l-.33.729c.114.05.235.069.347.055l-.096-.794Zm.078.01a.164.164 0 0 1 .066.06l-.662.449c.062.09.153.169.267.22l.329-.73Zm.066.06a.24.24 0 0 1 .03.061c.007.024.007.038.007.037h-.8c0 .15.042.264.101.35l.662-.448Zm-.363.098.4-.003v-.082a175.754 175.754 0 0 1-.007-1.075c-.004-.698-.008-1.638-.011-2.6-.006-1.938-.006-3.936.017-4.29l-.798-.052c-.026.39-.025 2.43-.02 4.344a1208.43 1208.43 0 0 0 .018 3.678v.061l.001.016v.005l.4-.002Zm.181-8.433a2.117 2.117 0 0 0-1.348-.194 2.264 2.264 0 0 0-.582.191l-.012.007-.004.002h-.002v.001h-.001l.195.35c.195.349.195.349.194.35h-.002.001a1.458 1.458 0 0 1 .355-.113c.229-.042.529-.04.844.12l.362-.714Zm-1.76-.043-.416.007.016.8.411-.007-.011-.8Zm-.808.407v1.551h.8v-1.551h-.8Zm.408 1.951.434-.008-.012-.8-.439.008.017.8Zm.028-.407v6.524h.8v-6.524h-.8Zm0 6.524c0 1.885 2.21 2.858 3.607 1.651l-.523-.605c-.887.766-2.284.142-2.284-1.046h-.8Zm3.607 1.651 13.063-11.28-.523-.606-13.063 11.28.523.606Zm13.063-11.28a2.182 2.182 0 0 0 0-3.303l-.523.606c.638.55.637 1.54 0 2.09l.523.606Zm0-3.303L25.582 1.307l-.523.606 13.063 11.28.523-.606ZM25.582 1.307c-1.399-1.208-3.607-.23-3.607 1.651h.8c0-1.186 1.396-1.812 2.284-1.045l.523-.606Zm-3.607 1.651V8.9h.8V2.958h-.8ZM22.37 8.5c-5.969.068-11.396.698-15.34 2.772-1.98 1.042-3.595 2.451-4.711 4.34C1.203 17.503.6 19.843.6 22.724h.8c0-2.767.579-4.962 1.608-6.703 1.028-1.74 2.522-3.055 4.395-4.04C11.166 10 16.427 9.368 22.38 9.3l-.01-.8ZM.6 22.723c0 4.716 3.023 9.344 6.35 11.763l.47-.647C4.252 31.535 1.4 27.128 1.4 22.723H.6Zm6.35 11.763a1.763 1.763 0 0 0 2.016.045c.567-.371.933-1.076.684-1.87l-.763.239c.125.4-.044.755-.36.961a.963.963 0 0 1-1.107-.022l-.47.647Zm2.7-1.825c-1.489-4.763-1.285-7.816.235-9.771 1.535-1.973 4.518-2.976 8.984-3.34l-.065-.796c-4.49.364-7.79 1.382-9.55 3.645-1.774 2.28-1.875 5.677-.367 10.5l.763-.238Zm9.587-13.509v-1.556h-.8v1.556h.8Zm-.431-1.954c-1.535.12-2.953.313-4.238.604l.176.78c1.238-.28 2.616-.469 4.124-.587l-.063-.797Zm-4.238.604c-2.213.5-4.172 1.319-5.646 2.676l.542.589c1.332-1.228 3.142-2.001 5.28-2.485l-.176-.78Zm-5.646 2.676c-2.996 2.76-3.234 6.932-1.742 12.13l.769-.222c-1.468-5.11-1.136-8.878 1.515-11.32l-.542-.588Zm-1.104 11.71C5.17 30.017 2.95 26.29 2.95 22.722h-.8c0 3.865 2.376 7.803 5.16 10.083l.507-.619ZM2.95 22.722c0-2.548.531-4.457 1.392-5.914l-.689-.407c-.947 1.604-1.503 3.66-1.503 6.321h.8Zm1.392-5.914c.858-1.453 2.119-2.582 3.782-3.456l-.372-.708C5.98 13.576 4.6 14.8 3.654 16.402l.689.407Zm3.782-3.456c3.414-1.796 8.351-2.435 14.272-2.502l-.009-.8c-5.937.067-11.041.703-14.635 2.594l.372.708Zm14.272-2.502 1.534-.018-.01-.8-1.533.018.01.8Zm1.929-.418V2.958h-.8v7.475h.8Zm0-7.475s0 .013-.007.037a.239.239 0 0 1-.03.062l-.662-.45a.607.607 0 0 0-.101.351h.8Zm-.037.099a.162.162 0 0 1-.065.059l-.33-.729a.64.64 0 0 0-.267.22l.662.45Zm-.065.059a.123.123 0 0 1-.031.009.175.175 0 0 1-.049 0l.096-.794a.655.655 0 0 0-.346.056l.33.729Z",
    fill: "#DF3045",
    mask: "url(#share_svg__a)"
  }));
};

var SvgShow = function SvgShow(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", {
    width: "20",
    height: "12",
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M0.493273 11.4962C0.164424 11.1603 0 10.7328 0 10.2137C0 9.69465 0.164424 9.26717 0.493273 8.9313L8.74439 0.503816C8.92377 0.32061 9.11809 0.190535 9.32735 0.113588C9.53662 0.0378631 9.76084 0 10 0C10.2392 0 10.4712 0.0458012 10.696 0.137404C10.9196 0.229007 11.1061 0.351144 11.2556 0.503816L19.5067 8.9313C19.8356 9.26717 20 9.69465 20 10.2137C20 10.7328 19.8356 11.1603 19.5067 11.4962C19.1779 11.8321 18.7593 12 18.2511 12C17.7429 12 17.3244 11.8321 16.9955 11.4962L10 4.35114L3.00448 11.4962C2.67564 11.8321 2.2571 12 1.74888 12C1.24066 12 0.822122 11.8321 0.493273 11.4962V11.4962Z",
    fill: "white"
  }));
};

var SvgStairs = function SvgStairs(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#stairs_svg__a)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M1.19 38.49V29.6h9.24v-9.41h9.58v-9.41h9.24V1.19h9.41",
    stroke: props.color,
    strokeWidth: 2.38,
    strokeLinejoin: "bevel"
  })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "stairs_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h38.66v38.49H0z"
  }))));
};

var _templateObject$Y, _templateObject2$E, _templateObject3$o;
var Row$1 = styled__default["default"].div(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteral(["\n  margin-top: 6px;\n  display: flex;\n  align-items: top;\n"])));
var Line = styled__default["default"].div(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteral(["\n  margin-left: -1px;\n  margin-top: 1px;\n  border-top: 2px solid ", ";\n  width: 100%;\n"])), function (props) {
  return props.color;
});
var Fixed = styled__default["default"].div(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral(["\n  min-width: 14px;\n  min-height: 15px;\n"])));
var TertiaryPoint = (function (_ref) {
  var color = _ref.color;
  return /*#__PURE__*/React__default["default"].createElement(Row$1, null, /*#__PURE__*/React__default["default"].createElement(Fixed, null, /*#__PURE__*/React__default["default"].createElement(SvgQuotePoint, {
    color: color
  })), /*#__PURE__*/React__default["default"].createElement(Line, {
    color: color
  }));
});

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    stroke: props.color || grey400,
    strokeWidth: 2,
    d: "M1 1h33v33H1z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M22.272 9.545c-2.586 0-4.74 2.208-4.138 4.932a12.562 12.562 0 0 1-4.841-1.219 11.932 11.932 0 0 1-3.897-2.978 3.841 3.841 0 0 0-.075 3.92c.329.583.805 1.08 1.387 1.446a4.418 4.418 0 0 1-1.914-.505v.046a3.886 3.886 0 0 0 .954 2.546 4.287 4.287 0 0 0 2.44 1.397 4.785 4.785 0 0 1-1.913.074c.271.798.799 1.495 1.51 1.994.71.5 1.568.776 2.452.79a8.804 8.804 0 0 1-5.26 1.714 9.535 9.535 0 0 1-1.022-.046 12.5 12.5 0 0 0 6.51 1.798c7.795 0 12.062-6.115 12.062-11.422 0-.172 0-.347-.015-.52a8.644 8.644 0 0 0 2.125-2.081 8.782 8.782 0 0 1-2.44.625 4.05 4.05 0 0 0 1.86-2.21c-.83.467-1.74.794-2.688.966a4.234 4.234 0 0 0-1.41-.939 4.43 4.43 0 0 0-1.689-.328h.002Z",
    fill: props.color || grey400
  }));
};

var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 25,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M12.76 2 23.6 12.376h-7.967M9.877 12.295H2L12.76 2",
    stroke: props.color,
    strokeWidth: 2.38,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var SvgWheelchair = function SvgWheelchair(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    width: 34,
    height: 47,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React__namespace.createElement("g", {
    clipPath: "url(#wheelchair_svg__a)",
    stroke: props.color,
    strokeWidth: 2.38,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M18.06 4.73a3.55 3.55 0 1 1-7.1.02 3.55 3.55 0 0 1 7.1-.02ZM23.24 39.49a11.91 11.91 0 1 1-16.8-16.12"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M27.43 21.12h-8.35v-8.35H9.79v20.64H21l8.27 8.27 3.39-3.39"
  })), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("clipPath", {
    id: "wheelchair_svg__a"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#fff",
    d: "M0 0h33.5v46.35H0z"
  }))));
};

// 35x35 svg ICONS FROM https://icons8.com/icon/set/social-media/material-outlined

var SvgX = function SvgX(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "35",
    height: "35",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M 2.3671875 3 L 9.4628906 13.140625 L 2.7402344 21 L 5.3808594 21 L 10.644531 14.830078 L 14.960938 21 L 21.871094 21 L 14.449219 10.375 L 20.740234 3 L 18.140625 3 L 13.271484 8.6875 L 9.2988281 3 L 2.3671875 3 z M 6.2070312 5 L 8.2558594 5 L 18.033203 19 L 16.001953 19 L 6.2070312 5 z",
    fill: props.color || grey400
  }));
};

// 35x35 svg ICONS FROM https://icons8.com/icon/set/social-media/material-outlined

var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "35",
    height: "35",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M 5 3 C 3.895 3 3 3.895 3 5 L 3 19 C 3 20.105 3.895 21 5 21 L 19 21 C 20.105 21 21 20.105 21 19 L 21 5 C 21 3.895 20.105 3 19 3 L 5 3 z M 5 5 L 19 5 L 19 19 L 5 19 L 5 5 z M 7.7792969 6.3164062 C 6.9222969 6.3164062 6.4082031 6.8315781 6.4082031 7.5175781 C 6.4082031 8.2035781 6.9223594 8.7167969 7.6933594 8.7167969 C 8.5503594 8.7167969 9.0644531 8.2035781 9.0644531 7.5175781 C 9.0644531 6.8315781 8.5502969 6.3164062 7.7792969 6.3164062 z M 6.4765625 10 L 6.4765625 17 L 9 17 L 9 10 L 6.4765625 10 z M 11.082031 10 L 11.082031 17 L 13.605469 17 L 13.605469 13.173828 C 13.605469 12.034828 14.418109 11.871094 14.662109 11.871094 C 14.906109 11.871094 15.558594 12.115828 15.558594 13.173828 L 15.558594 17 L 18 17 L 18 13.173828 C 18 10.976828 17.023734 10 15.802734 10 C 14.581734 10 13.930469 10.406562 13.605469 10.976562 L 13.605469 10 L 11.082031 10 z",
    fill: props.color || grey400
  }));
};

// 35x35 svg ICONS FROM https://icons8.com/icon/set/social-media/material-outlined

var SvgYouTube = function SvgYouTube(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "35",
    height: "35",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M 5.6796875 2 L 7.1582031 7.34375 L 7.1582031 9.90625 L 8.4394531 9.90625 L 8.4394531 7.34375 L 9.9375 2 L 8.6464844 2 L 8.109375 4.4316406 C 7.958375 5.1416406 7.8623594 5.6462656 7.8183594 5.9472656 L 7.7792969 5.9472656 C 7.7162969 5.5262656 7.6202813 5.017875 7.4882812 4.421875 L 6.9707031 2 L 5.6796875 2 z M 11.431641 4.0175781 C 10.997641 4.0175781 10.647859 4.1023906 10.380859 4.2753906 C 10.113859 4.4473906 9.9170156 4.7226094 9.7910156 5.0996094 C 9.6660156 5.4766094 9.6035156 5.9756563 9.6035156 6.5976562 L 9.6035156 7.4375 C 9.6035156 8.0525 9.6575781 8.5450156 9.7675781 8.9160156 C 9.8775781 9.2870156 10.063219 9.5603281 10.324219 9.7363281 C 10.585219 9.9123281 10.944344 10 11.402344 10 C 11.848344 10 12.202891 9.9132344 12.462891 9.7402344 C 12.722891 9.5672344 12.911344 9.295875 13.027344 8.921875 C 13.143344 8.547875 13.201172 8.0535 13.201172 7.4375 L 13.201172 6.5976562 C 13.201172 5.9766562 13.142437 5.4794687 13.023438 5.1054688 C 12.904438 4.7324687 12.715031 4.45725 12.457031 4.28125 C 12.199031 4.10525 11.858641 4.0175781 11.431641 4.0175781 z M 13.878906 4.1308594 L 13.878906 8.4453125 C 13.878906 8.9793125 13.968391 9.3720469 14.150391 9.6230469 C 14.332391 9.8740469 14.615047 10 14.998047 10 C 15.550047 10 15.966187 9.7332188 16.242188 9.1992188 L 16.269531 9.1992188 L 16.382812 9.90625 L 17.400391 9.90625 L 17.400391 4.1308594 L 16.101562 4.1308594 L 16.101562 8.71875 C 16.051563 8.82575 15.975094 8.9134219 15.871094 8.9824219 C 15.767094 9.0524219 15.659875 9.0859375 15.546875 9.0859375 C 15.414875 9.0859375 15.320672 9.031875 15.263672 8.921875 C 15.206672 8.811875 15.177734 8.6271406 15.177734 8.3691406 L 15.177734 4.1308594 L 13.878906 4.1308594 z M 11.402344 4.9121094 C 11.584344 4.9121094 11.713156 5.0072187 11.785156 5.1992188 C 11.857156 5.3902187 11.892578 5.694375 11.892578 6.109375 L 11.892578 7.9082031 C 11.892578 8.3352031 11.857156 8.6440312 11.785156 8.8320312 C 11.713156 9.0200312 11.585297 9.1142344 11.404297 9.1152344 C 11.222297 9.1152344 11.096344 9.0200313 11.027344 8.8320312 C 10.957344 8.6440313 10.923828 8.3352031 10.923828 7.9082031 L 10.923828 6.109375 C 10.923828 5.695375 10.95925 5.3912188 11.03125 5.1992188 C 11.10325 5.0082187 11.226344 4.9121094 11.402344 4.9121094 z M 5 11 C 3.9 11 3 11.9 3 13 L 3 20 C 3 21.1 3.9 22 5 22 L 19 22 C 20.1 22 21 21.1 21 20 L 21 13 C 21 11.9 20.1 11 19 11 L 5 11 z M 12.048828 13 L 13.105469 13 L 13.105469 15.568359 L 13.113281 15.568359 C 13.208281 15.382359 13.344531 15.233141 13.519531 15.119141 C 13.694531 15.005141 13.883938 14.949219 14.085938 14.949219 C 14.345937 14.949219 14.549266 15.01825 14.697266 15.15625 C 14.845266 15.29425 14.953531 15.517219 15.019531 15.824219 C 15.085531 16.132219 15.117187 16.559469 15.117188 17.105469 L 15.117188 17.876953 L 15.119141 17.876953 C 15.119141 18.603953 15.030469 19.136516 14.855469 19.478516 C 14.680469 19.820516 14.408109 19.992188 14.037109 19.992188 C 13.830109 19.992188 13.642656 19.944609 13.472656 19.849609 C 13.302656 19.754609 13.174844 19.623984 13.089844 19.458984 L 13.066406 19.458984 L 12.955078 19.919922 L 12.048828 19.919922 L 12.048828 13 z M 5.4863281 13.246094 L 8.7382812 13.246094 L 8.7382812 14.130859 L 7.6484375 14.130859 L 7.6484375 19.919922 L 6.5761719 19.919922 L 6.5761719 14.130859 L 5.4863281 14.130859 L 5.4863281 13.246094 z M 17.097656 14.951172 C 17.473656 14.951172 17.762844 15.020203 17.964844 15.158203 C 18.165844 15.296203 18.307625 15.511734 18.390625 15.802734 C 18.472625 16.094734 18.513672 16.497719 18.513672 17.011719 L 18.513672 17.847656 L 16.677734 17.847656 L 16.677734 18.095703 C 16.677734 18.408703 16.686078 18.642828 16.705078 18.798828 C 16.724078 18.954828 16.762312 19.069625 16.820312 19.140625 C 16.878312 19.212625 16.967844 19.248047 17.089844 19.248047 C 17.253844 19.248047 17.366734 19.183641 17.427734 19.056641 C 17.488734 18.929641 17.522344 18.718875 17.527344 18.421875 L 18.474609 18.476562 C 18.479609 18.518563 18.482422 18.578344 18.482422 18.652344 C 18.482422 19.103344 18.358328 19.440109 18.111328 19.662109 C 17.864328 19.885109 17.517406 19.996094 17.066406 19.996094 C 16.525406 19.996094 16.145734 19.825328 15.927734 19.486328 C 15.709734 19.147328 15.601562 18.623109 15.601562 17.912109 L 15.601562 17.060547 C 15.601562 16.328547 15.714453 15.794031 15.939453 15.457031 C 16.164453 15.120031 16.551656 14.951172 17.097656 14.951172 z M 8.4101562 15.044922 L 9.5097656 15.044922 L 9.5097656 18.625 C 9.5097656 18.842 9.5340312 18.997844 9.5820312 19.089844 C 9.6300313 19.182844 9.7083125 19.228516 9.8203125 19.228516 C 9.9153125 19.228516 10.008703 19.199625 10.095703 19.140625 C 10.183703 19.082625 10.246062 19.007969 10.289062 18.917969 L 10.289062 15.044922 L 11.388672 15.044922 L 11.388672 19.919922 L 11.386719 19.919922 L 10.527344 19.919922 L 10.433594 19.322266 L 10.408203 19.322266 C 10.174203 19.774266 9.8244219 20 9.3574219 20 C 9.0334219 20 8.7965781 19.893641 8.6425781 19.681641 C 8.4885781 19.469641 8.4101563 19.1375 8.4101562 18.6875 L 8.4101562 15.044922 z M 17.074219 15.693359 C 16.957219 15.693359 16.870453 15.728875 16.814453 15.796875 C 16.758453 15.865875 16.721125 15.978766 16.703125 16.134766 C 16.684125 16.290766 16.675781 16.527703 16.675781 16.845703 L 16.675781 17.195312 L 17.478516 17.195312 L 17.478516 16.845703 C 17.478516 16.532703 17.468266 16.296766 17.447266 16.134766 C 17.427266 15.972766 17.388031 15.858969 17.332031 15.792969 C 17.276031 15.726969 17.191219 15.693359 17.074219 15.693359 z M 13.591797 15.728516 C 13.485797 15.728516 13.388828 15.770469 13.298828 15.855469 C 13.208828 15.940469 13.144422 16.049641 13.107422 16.181641 L 13.107422 18.949219 C 13.155422 19.034219 13.217922 19.097625 13.294922 19.140625 C 13.371922 19.182625 13.453922 19.205078 13.544922 19.205078 C 13.661922 19.205078 13.753266 19.163125 13.822266 19.078125 C 13.891266 18.993125 13.941703 18.850437 13.970703 18.648438 C 13.999703 18.447437 14.013672 18.1675 14.013672 17.8125 L 14.013672 17.185547 C 14.013672 16.803547 14.002516 16.509734 13.978516 16.302734 C 13.954516 16.095734 13.911562 15.946375 13.851562 15.859375 C 13.790563 15.772375 13.703797 15.728516 13.591797 15.728516 z",
    fill: props.color || grey400
  }));
};

var Icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ArrowLeft: SvgArrowLeft,
  ArrowRight: SvgArrowRight,
  Bag: SvgBag,
  Caret: SvgCaret,
  Close: Close,
  Down: SvgDown,
  Download: SvgDownload,
  Elevator: SvgElevator,
  Expand: SvgExpand,
  Facebook: SvgFacebook,
  Faucet: SvgFaucet,
  Instagram: SvgInstagram,
  Hamburger: Hamburger,
  Hanger: SvgHanger,
  HeadingQuoteRightMobile: SvgHeadingQuoteRightMobile,
  HeadingQuoteRight: SvgHeadingQuoteRight,
  Hide: SvgHide,
  Iiif: SvgIiif,
  JourneylinePrimaryDown: SvgJourneylinePrimaryDown,
  JourneylinePrimaryUp: SvgJourneylinePrimaryUp,
  Left: SvgLeft,
  MagnifyingGlass: SvgMagnifyingGlass,
  Mask: SvgMask,
  Pinterest: SvgPinterest,
  PointFilled: SvgPointFilled,
  Print: SvgPrint,
  QuotePoint: SvgQuotePoint,
  Right: SvgRight,
  Share: SvgShare,
  Show: SvgShow,
  Stairs: SvgStairs,
  TertiaryPoint: TertiaryPoint,
  Twitter: SvgTwitter,
  Up: SvgUp,
  Wheelchair: SvgWheelchair,
  X: SvgX,
  Linkedin: SvgLinkedin,
  Youtube: SvgYouTube
});

var SvgQuestionMark = function SvgQuestionMark(props) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.8,
    height: 153.6,
    viewBox: "0 0 54.187 40.64"
  }, props), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M29.898 26.572h-4.392a94.437 94.437 0 0 1-.018-1.158c0-1.423.235-2.593.706-3.51.47-.923 1.417-1.952 2.828-3.105 1.411-1.146 2.258-1.899 2.528-2.258.43-.558.641-1.181.641-1.857 0-.941-.376-1.747-1.129-2.423-.753-.67-1.764-1.005-3.04-1.005-1.228 0-2.257.352-3.086 1.052-.824.7-1.394 1.77-1.705 3.205l-4.44-.553c.124-2.058 1-3.804 2.623-5.239 1.628-1.434 3.757-2.152 6.403-2.152 2.775 0 4.985.73 6.632 2.182 1.64 1.452 2.463 3.14 2.463 5.074 0 1.064-.305 2.075-.905 3.028-.606.952-1.893 2.252-3.869 3.892-1.023.852-1.658 1.535-1.905 2.052-.247.517-.359 1.44-.335 2.775zm-4.392 6.509v-4.839h4.839v4.839h-4.84z"
  }));
};

var icons = {};
Object.keys(Icons).forEach(function (key) {
  return icons[kebabCase__default["default"](key)] = Icons[key];
});
var Icon = (function (props) {
  var _props$width = props.width,
    width = _props$width === void 0 ? 'fit-content' : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? '64px' : _props$height;
  var Icon = icons["-".concat(props.icon)] ? icons["-".concat(props.icon)] : SvgQuestionMark;
  return /*#__PURE__*/React__default["default"].createElement(Box, {
    w: width,
    h: height
  }, /*#__PURE__*/React__default["default"].createElement(Icon, props));
});

var breakpoints = {
  mobile: 0,
  tabletSmall: 769,
  tablet: 1024,
  desktop: 1025
};

var _templateObject$X, _templateObject2$D, _templateObject3$n, _templateObject4$h, _templateObject5$7, _templateObject6$3, _templateObject7$2, _templateObject8$2, _templateObject9$2;
var Base = styled__default["default"].button(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral(["\n  width: ", "; \n  background: ", ";\n  border: none;\n  cursor: ", ";\n  padding: 10px;\n"])), function (props) {
  return props.liquid ? '100%' : 'fit-content';
}, function (props) {
  return props.background ? props.background : 'transparent';
}, function (props) {
  return props.disabled ? 'arrow' : 'pointer';
});
var EyebrowButton = styled__default["default"].button(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteral(["\n  width: ", "; \n  border: 2px solid ", ";\n  cursor: ", ";\n  background: ", ";\n"])), function (props) {
  return props.liquid ? '100%' : 'fit-content';
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.disabled ? 'arrow' : 'pointer';
}, function (props) {
  return props.background ? props.background : 'transparent';
});
var Outline = styled__default["default"].button(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\n  padding: ", ";\n  width: ", "; \n  border: 2px solid ", ";\n  cursor: ", ";\n  background: transparent;\n"])), function (props) {
  return props.compact ? '12px 12px' : '20px 16px';
}, function (props) {
  return props.liquid ? '100%' : 'fit-content';
}, function (props) {
  return props.color || 'black';
}, function (props) {
  return props.disabled ? 'arrow' : 'pointer';
});
var Label$2 = styled__default["default"](Body)(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral(["\n  margin: 0;\n"])));
var PrimaryContainer = styled__default["default"](Box)(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var IconContainer = styled__default["default"](Base)(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: ", ";  \n  margin-right: 5px;\n  cursor: ", ";\n"])), function (props) {
  if (props.transparent) return 'transparent';
  if (props.background) return props.background;
  var out = props.dark ? props.color || 'transparent' : 'white';
  if (props.disabled) {
    out = grey600;
  }
  return out;
}, function (props) {
  return props.disabled ? 'arrow' : 'pointer';
});
var PrimaryBase = styled__default["default"].button(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n  padding: ", ";\n  width: ", "; \n  background: ", ";\n  border: none;\n  cursor: ", ";\n"])), function (props) {
  return props.compact ? '12px 12px' : '20px 16px';
}, function (props) {
  return props.liquid ? '100%' : 'fit-content';
}, function (props) {
  return props.color || red;
}, function (props) {
  return props.disabled ? 'arrow' : 'pointer';
});
var PrimaryPoint = styled__default["default"](Box)(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n  padding: 0;\n  margin-top: -1px;\n"])), function (props) {
  return props.compact ? '7px' : '18px';
});
var HoverContainer = styled__default["default"](FlexBox)(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n  background-color: white;\n  position: absolute;\n  border: 1px solid black;\n  z-index: 1000;\n"])));
var Button = (function (_ref) {
  var variant = _ref.variant,
    color = _ref.color,
    dark = _ref.dark,
    bold = _ref.bold,
    compact = _ref.compact,
    label = _ref.label,
    onClick = _ref.onClick,
    icon = _ref.icon,
    disabled = _ref.disabled,
    liquid = _ref.liquid,
    width = _ref.width,
    height = _ref.height,
    content = _ref.content,
    transparent = _ref.transparent,
    background = _ref.background,
    padding = _ref.padding;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var noop = function noop() {};
  var renderVariant = function renderVariant() {
    switch (variant) {
      case 'primary':
        return /*#__PURE__*/React__default["default"].createElement(PrimaryContainer, null, /*#__PURE__*/React__default["default"].createElement(PrimaryBase, {
          liquid: liquid,
          compact: compact,
          color: dark ? 'white' : color,
          disabled: disabled,
          onClick: disabled ? noop : onClick
        }, /*#__PURE__*/React__default["default"].createElement(Label$2, {
          bold: true,
          color: dark ? color : 'white'
        }, label)), /*#__PURE__*/React__default["default"].createElement(PrimaryPoint, {
          compact: compact
        }, /*#__PURE__*/React__default["default"].createElement(SvgPointFilled, {
          color: dark ? 'white' : color
        })));
      case 'tertiary':
        return /*#__PURE__*/React__default["default"].createElement(Base, {
          liquid: liquid,
          disabled: disabled,
          onClick: disabled ? noop : onClick
        }, /*#__PURE__*/React__default["default"].createElement(Body, {
          bold: true,
          color: dark ? 'white' : color || 'black'
        }, label), /*#__PURE__*/React__default["default"].createElement(TertiaryPoint, {
          color: dark ? "white" : red
        }));
      case 'text':
        return /*#__PURE__*/React__default["default"].createElement(Base, {
          disabled: disabled,
          onClick: disabled ? noop : onClick,
          liquid: liquid
        }, /*#__PURE__*/React__default["default"].createElement(Body, {
          textAlign: "left",
          bold: bold,
          variant: compact ? 'small' : undefined,
          color: dark ? 'white' : color
        }, label));
      case 'textcarat':
        return /*#__PURE__*/React__default["default"].createElement(Base, {
          disabled: disabled,
          onClick: disabled ? noop : onClick,
          liquid: liquid,
          background: dark ? color : 'white'
        }, /*#__PURE__*/React__default["default"].createElement(Body, {
          textAlign: "left",
          bold: "bold",
          variant: "small",
          color: dark ? 'white' : color
        }, label, " >"));
      case 'hovericon':
        var hoverIconDimension = breakpoint === 'mobile' ? '20px' : '30px';
        var hoverTextVariant = breakpoint === 'mobile' ? 'tiny' : 'small';
        var linkRef = React$1.useRef();
        var _useState = React$1.useState(null),
          _useState2 = _slicedToArray(_useState, 2),
          open = _useState2[0],
          setOpen = _useState2[1];
        var handleMouseOver = function handleMouseOver() {
          setOpen(true);
        };
        var handleMouseOut = function handleMouseOut() {
          setOpen(false);
        };
        return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
          textAlign: "right",
          flexDirection: "column"
        }, /*#__PURE__*/React__default["default"].createElement(IconContainer, {
          dark: dark,
          color: color,
          disabled: disabled,
          onClick: disabled ? noop : onClick,
          width: width ? width : hoverIconDimension,
          height: height ? height : hoverIconDimension,
          onMouseEnter: handleMouseOver,
          onMouseLeave: handleMouseOut,
          transparent: transparent,
          background: background
        }, /*#__PURE__*/React__default["default"].createElement(Box, null, /*#__PURE__*/React__default["default"].createElement(Icon, {
          icon: icon,
          color: dark ? white : color,
          width: width ? width : hoverIconDimension,
          height: height ? height : hoverIconDimension
        })), /*#__PURE__*/React__default["default"].createElement(Label$2, {
          bold: true,
          color: dark ? white : black,
          variant: hoverTextVariant
        }, label)), open && /*#__PURE__*/React__default["default"].createElement(HoverContainer, {
          ref: linkRef,
          flexDirection: "column",
          onMouseEnter: handleMouseOver,
          onMouseLeave: handleMouseOut,
          w: breakpoint === 'mobile' ? '240px' : '300px',
          ml: breakpoint === 'mobile' ? '-110px' : '-270px',
          mt: breakpoint === 'mobile' ? '40px' : '55px',
          padding: "10px"
        }, content));
      case 'icon':
        var iconDimension = breakpoint === 'mobile' ? '20px' : '30px';
        var textVariant = breakpoint === 'mobile' ? 'tiny' : 'small';
        return /*#__PURE__*/React__default["default"].createElement(IconContainer, {
          dark: dark,
          color: color,
          disabled: disabled,
          onClick: disabled ? noop : onClick,
          width: width ? width : iconDimension,
          height: height ? height : iconDimension,
          transparent: transparent,
          background: background
        }, /*#__PURE__*/React__default["default"].createElement(Box, {
          pl: padding,
          pr: padding
        }, /*#__PURE__*/React__default["default"].createElement(Icon, {
          icon: icon,
          color: dark ? white : color,
          width: width ? width : iconDimension,
          height: height ? height : iconDimension
        })), /*#__PURE__*/React__default["default"].createElement(Label$2, {
          bold: true,
          color: dark ? white : black,
          variant: textVariant
        }, label));
      case "eyebrow":
        return /*#__PURE__*/React__default["default"].createElement(EyebrowButton, {
          color: color,
          background: background,
          liquid: liquid,
          compact: compact,
          disabled: disabled,
          onClick: disabled ? noop : onClick
        }, /*#__PURE__*/React__default["default"].createElement(Label$2, {
          bold: true,
          variant: "tiny",
          color: dark ? 'white' : color
        }, label));
      default:
        return /*#__PURE__*/React__default["default"].createElement(Outline, {
          color: dark ? 'white' : color,
          background: background,
          dark: dark,
          liquid: liquid,
          compact: compact,
          disabled: disabled,
          onClick: disabled ? noop : onClick
        }, /*#__PURE__*/React__default["default"].createElement(Label$2, {
          bold: true,
          color: dark ? 'white' : color
        }, label));
    }
  };
  return renderVariant();
});

var _templateObject$W;
var Container$C = styled__default["default"](Box)(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: visible;\n\n  @media (min-width: 1025px) {\n    padding: 20px 48px;\n  }\n\n  @media (max-width: 1024px) {\n    padding: 20px 24px;\n  }\n"])));

var _templateObject$V;
var LogoImg = styled__default["default"].div(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  visibility: ", ";\n  ", "\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.visibility && 'hidden';
}, function (props) {
  return props.dark ? "\n      background-color: ".concat(white, ";\n      mask-image: url('/logo.svg');\n      mask-repeat: no-repeat;\n      mask-size: contain;\n    ") : "\n      background-image: url('/logo.svg');\n      background-repeat: no-repeat;\n      background-size: contain;\n    ";
});
var Logo = (function (_ref) {
  var dark = _ref.dark,
    variant = _ref.variant,
    width = _ref.width,
    height = _ref.height,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default["default"].createElement(LogoImg, {
    variant: variant,
    width: width || '187px',
    height: height || '126px',
    dark: dark || undefined,
    onClick: onClick
  });
});

var _templateObject$U;
var Container$B = styled__default["default"](Box)(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n\n  & h1 {\n    margin: ", ";\n  }\n"])), function (props) {
  return props.variant === 'horizontal' ? 'row-reverse' : 'column';
}, function (props) {
  return props.variant === 'horizontal' ? '0 20px 0 0' : '0';
});
var HeroHeader = (function (_ref) {
  var color = _ref.color,
    boldText = _ref.boldText,
    lightText = _ref.lightText,
    shadow = _ref.shadow,
    dark = _ref.dark,
    variant = _ref.variant;
  return /*#__PURE__*/React__default["default"].createElement(Container$B, {
    variant: variant
  }, variant === 'reverse' ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(H1, {
    shadow: shadow,
    dark: dark,
    color: color
  }, boldText), /*#__PURE__*/React__default["default"].createElement(H1, {
    shadow: shadow,
    dark: dark,
    color: color,
    light: true
  }, lightText)) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(H1, {
    shadow: shadow,
    dark: dark,
    color: color,
    light: true
  }, lightText), /*#__PURE__*/React__default["default"].createElement(H1, {
    shadow: shadow,
    dark: dark,
    color: color
  }, boldText)));
});

var _templateObject$T, _templateObject2$C;
var Tag = styled__default["default"].div(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n  padding: 5px;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  background: ", ";\n  margin-left: 10px;\n  &:first-child {\n    margin-left: 0;\n  }\n"])), function (props) {
  return props.priority ? red : white;
});
var Label$1 = styled__default["default"](Caption)(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return props.priority ? white : grey200;
});
var Tag$1 = (function (_ref) {
  var label = _ref.label,
    priority = _ref.priority;
  return /*#__PURE__*/React__default["default"].createElement(Tag, {
    priority: priority
  }, /*#__PURE__*/React__default["default"].createElement(Label$1, {
    bold: true,
    priority: priority
  }, label));
});

var _templateObject$S, _templateObject2$B, _templateObject3$m, _templateObject4$g, _templateObject5$6;
var TagRow$1 = styled__default["default"](Box)(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  top: 11px;\n  right: 11px;\n  z-index: 3;\n"])));
var Container$A = styled__default["default"](Box)(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n"])));
var Image = styled__default["default"].img(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  transition: 1.2s;\n  ", "\n  ", "\n  ", "\n"])), function (props) {
  return props.fit ? 'object-fit: ' + props.fit + ';' : 'object-fit: cover;';
}, function (props) {
  return props.onClick ? 'cursor: pointer;' : '';
}, function (props) {
  return props.square ? 'aspect-ratio: 1 / 1;' : '';
});
var Placeholder$1 = styled__default["default"](Box)(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n"])), grey400);
var Content$3 = styled__default["default"](Box)(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n  z-index: 4;\n  position: absolute;\n  left: 24px;\n  bottom: 24px;\n"])));
var Image$1 = (function (_ref) {
  var src = _ref.src,
    tags = _ref.tags,
    content = _ref.content,
    square = _ref.square,
    alt = _ref.alt,
    onclick = _ref.onclick,
    fit = _ref.fit,
    title = _ref.title,
    zoom = _ref.zoom;
  var _useState = React$1.useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var handleLoaded = function handleLoaded() {
    return setLoading(false);
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$A, null, /*#__PURE__*/React__default["default"].createElement(Image, {
    src: src,
    onLoad: handleLoaded,
    alt: alt,
    title: title,
    fit: fit,
    square: square,
    onClick: onclick,
    style: zoom ? {
      transform: 'scale(1.1)'
    } : {
      transform: 'scale(1.0)'
    }
  }), loading && /*#__PURE__*/React__default["default"].createElement(Placeholder$1, null, /*#__PURE__*/React__default["default"].createElement("img", {
    src: "/loading.gif",
    width: "50px",
    height: "50px"
  })), tags && tags.length > 0 && /*#__PURE__*/React__default["default"].createElement(TagRow$1, null, tags.map(function (t) {
    return /*#__PURE__*/React__default["default"].createElement(Tag$1, t);
  })), content && /*#__PURE__*/React__default["default"].createElement(Content$3, null, content));
});

var _templateObject$R;
var Divider$1 = styled__default["default"].div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n    height: 1px;\n    width: 100%;\n    background-color:  ", ";\n    margin: ", ";\n"])), function (props) {
  return props.color ? props.color : grey600;
}, function (props) {
  return props.margin ? props.margin : '30px 0';
});

var _templateObject$Q;
var Container$z = styled__default["default"](Box)(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 60px 52px 0 52px;\n  background-image: url(journeyline-callout.svg);\n  background-repeat: no-repeat;\n"])));
var JourneylineCalloutSection = (function (_ref) {
  var color = _ref.color,
    children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(Container$z, null, /*#__PURE__*/React__default["default"].createElement(Box, {
    backgroundColor: color
  }, children));
});

var _templateObject$P, _templateObject2$A;
// import useBreakpoint from 'use-breakpoint';

var Container$y = styled__default["default"](Box)(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100vw;\n"])));
var Background$1 = styled__default["default"](Box)(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteral(["\n  z-index: -1;\n  background-repeat: no-repeat;\n  \n  width: 100vw;\n  padding: 20px 0;\n  margin-bottom: 30px;\n  position: absolute;\n  min-height: 500px;\n\n  top: ", ";\n\n  height: ", ";\n\n  @media (max-width: 600px) {\n    background-image: url(", ");\n\n    margin-top: -80px;\n\n    background-position: ", ";\n  }\n\n  @media (min-width: 601px) and (max-width: 1024px) {\n    background-image: url(", ");\n\n    background-position: ", ";\n\n    ", "\n    ", "\n  }\n\n  @media (min-width: 1025px) {\n    background-image: url(", ");\n\n    background-position: ", ";\n\n    ", "\n    ", "\n  }\n"])), function (props) {
  switch (props.variant) {
    case 'secondary-right':
      return '-130px';
    case 'primary-up':
      return '-45px';
    case 'quote-box':
      return '-50px';
  }
}, function (props) {
  return props.variant === 'quote-box' ? '880px' : '600px';
}, function (props) {
  switch (props.variant) {
    case 'top':
      return '/journeyline-secondary-top-mobile.svg';
    case 'middle':
      return '/journeyline-secondary-middle-mobile.svg';
    case 'bottom':
      return '/journeyline-secondary-bottom-mobile.svg';
  }
}, function (props) {
  switch (props.variant) {
    case 'top':
      return '50px 0';
  }
}, function (props) {
  switch (props.variant) {
    case 'primary-up':
      return '/journeyline-primary-up-tablet.svg';
    case 'primary-down':
      return '/journeyline-primary-down.svg';
    case 'secondary-right':
      return '/journeyline-secondary-right.svg';
    case 'quote-box':
      return '/journeyline-quote-box-tablet.svg';
  }
}, function (props) {
  switch (props.variant) {
    case 'primary-up':
      return '40px 80px;';
    case 'primary-down':
      return 'top 200px;';
    case 'secondary-right':
      return 'left calc(100% + 415px) top 170px;';
    case 'quote-box':
      return 'calc(100% - 10px);';
  }
}, function (props) {
  return props.variant === 'primary-up' ? 'margin-top: -200px;' : '';
}, function (props) {
  return props.variant === 'quote-box' ? 'margin-top: -190px;' : '';
}, function (props) {
  switch (props.variant) {
    case 'primary-up':
      return '/journeyline-primary-up.svg';
    case 'primary-down':
      return '/journeyline-primary-down.svg';
    case 'secondary-right':
      return '/journeyline-secondary-right.svg';
    case 'quote-box':
      return '/journeyline-quote-box.svg';
  }
}, function (props) {
  switch (props.variant) {
    case 'primary-up':
      return 'left 160px top -140px;';
    case 'primary-down':
      return 'top 200px;';
    case 'secondary-right':
      return 'left calc(100% + 230px) top 250px;';
    case 'quote-box':
      return 'calc(80% - 70px);';
  }
}, function (props) {
  return props.variant === 'primary-up' ? 'margin-top: -100px;' : '';
}, function (props) {
  return props.variant === 'quote-box' ? 'margin-top: -155px;' : '';
});
var JourneylineSection = function JourneylineSection(_ref) {
  var variant = _ref.variant,
    children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(Container$y, null, /*#__PURE__*/React__default["default"].createElement(Background$1, {
    variant: variant
  }), children);
};

var _templateObject$O, _templateObject2$z;
var Container$x = styled__default["default"](Box)(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"])));
var Placeholder = styled__default["default"](Box)(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  background-color: ", ";\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n"])), grey400);
var Loading = (function () {
  return /*#__PURE__*/React__default["default"].createElement(Container$x, null, /*#__PURE__*/React__default["default"].createElement(Placeholder, null, /*#__PURE__*/React__default["default"].createElement("img", {
    src: "/loading.gif",
    width: "50px",
    height: "50px"
  })));
});

var _templateObject$N, _templateObject2$y;
var Container$w = styled__default["default"](Box)(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var Arrow = styled__default["default"](Icon)(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral(["\n  @keyframes fade {\n    0% {opacity: 0;}\n    100% {opacity: 1;}\n  }\n\n  animation-name: fade;\n  margin-left: 10px;\n  height: 24px;\n"])));
var MenuButton = (function (_ref) {
  var label = _ref.label,
    navigate = _ref.navigate,
    slug = _ref.slug,
    toggle = _ref.toggle;
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    over = _useState2[0],
    setOver = _useState2[1];
  var handleHover = function handleHover(hovering) {
    return function () {
      setOver(hovering);
    };
  };
  var click = function click() {
    toggle();
    navigate(slug);
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$w, {
    mt: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    dark: true,
    variant: "text",
    label: label,
    onClick: click,
    onMouseEnter: handleHover(true),
    onMouseLeave: handleHover(false)
  }), over && /*#__PURE__*/React__default["default"].createElement(Arrow, {
    icon: "right",
    color: "white"
  }));
});

var _templateObject$M, _templateObject2$x;
var Container$v = styled__default["default"](Box)(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n  background-repeat: no-repeat;\n\n  @media (min-width: 1025px) {\n    width: 705px;\n    height: 715px;\n    padding: 0 48px 100px 48px;\n    background-image: url('/journeyline-half-quote-box-", ".svg');\n    background-position: 0 75px;\n  }\n\n  @media (max-width: 1024px) {\n    width: 513px;\n    height: 509px;\n    ", "\n    background-image: url('/journeyline-half-quote-box-", "-tablet.svg');\n    background-position: 0;\n  }\n\n  @media (max-width: 768px) {\n    width: 289px;\n    height: 297px;\n    ", "\n    background-image: url('/journeyline-half-quote-box-", "-mobile.svg');\n    background-position: 0 10px;\n  }\n"])), function (props) {
  return props.variant === 'right' ? 'left' : 'right';
}, function (props) {
  return props.variant === 'right' ? 'padding: 0 36px 100px 36px;' : 'padding: 0 48px 100px 24px;';
}, function (props) {
  return props.variant === 'right' ? 'left' : 'right';
}, function (props) {
  return props.variant === 'right' ? 'padding: 0 24px 50px 24px;' : 'padding: 0 24px 50px 24px;';
}, function (props) {
  return props.variant === 'right' ? 'left' : 'right';
});
var ImageBox = styled__default["default"](Box)(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral(["\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n"])));
var QuoteBoxImage = (function (_ref) {
  var variant = _ref.variant,
    image = _ref.image;
  return /*#__PURE__*/React__default["default"].createElement(Container$v, {
    variant: variant
  }, /*#__PURE__*/React__default["default"].createElement(ImageBox, null, /*#__PURE__*/React__default["default"].createElement(Image$1, {
    src: image
  })));
});

var _templateObject$L;
var Filter$1 = styled__default["default"].select(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n  appearance: none;\n\n  background-image: url(/", ");\n  background-repeat: no-repeat;\n  background-position: right;\n\n  border: none;\n  padding: 10px 0 5px 0;\n\n  border-bottom: 1px solid ", ";\n\n  width: 100%;\n  min-height: 46.5px;\n\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid ", ";\n  }\n"])), function (props) {
  return props.icon ? "".concat(props.icon, ".svg") : 'down.svg';
}, grey400, red);

var RangeFilter = (function (_ref) {
  var onChange = _ref.onChange,
    label = _ref.label,
    options = _ref.options,
    defaults = _ref.defaults;
  var _useState = React$1.useState([defaults !== null && defaults !== void 0 && defaults.from ? defaults.from : options[0].value, defaults !== null && defaults !== void 0 && defaults.to ? defaults.to : options[options.length - 1].value]),
    _useState2 = _slicedToArray(_useState, 2),
    range = _useState2[0],
    setRange = _useState2[1];
  var handleFrom = function handleFrom(e) {
    var value = e.target.value;
    var nextRange = value <= range[1] ? [value, range[1]] : [range[1], value];
    setRange(nextRange);
    onChange(nextRange);
  };
  var handleTo = function handleTo(e) {
    var value = e.target.value;
    var nextRange = value >= range[0] ? [range[0], value] : [value, range[0]];
    setRange(nextRange);
    onChange(nextRange);
  };
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    alignItems: "center",
    mb: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    alignItems: "baseline",
    padding: "0",
    w: "120px",
    mr: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    bold: true
  }, label), /*#__PURE__*/React__default["default"].createElement(Filter$1, {
    onChange: handleFrom,
    value: range[0]
  }, options.map(function (option, index) {
    return /*#__PURE__*/React__default["default"].createElement("option", {
      key: index,
      value: option.value
    }, option.label);
  }))), /*#__PURE__*/React__default["default"].createElement(Box, {
    mt: "25px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    bold: true
  }, "TO")), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    alignItems: "baseline",
    padding: "0",
    mt: "25px",
    w: "120px",
    ml: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(Filter$1, {
    onChange: handleTo,
    value: range[1]
  }, options.map(function (option, index) {
    return /*#__PURE__*/React__default["default"].createElement("option", {
      key: index,
      value: option.value
    }, option.label);
  }))));
});

var _templateObject$K;
var Input$1 = styled__default["default"].input(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n  font-family: usual;\n  font-size: 14px;\n  font-weight: 200;\n  color: ", ";\n\n\n  border: none;\n\n  border-bottom: 1px solid ", ";\n\n  width: 100%;\n  min-width: 130px;\n  min-height: 46.5px;\n\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid ", ";\n  }\n\n  &::-webkit-calendar-picker-indicator {\n    background-image: url(/calendar.svg);\n  }\n"])), grey400, grey400, red);
var DateInput = (function (_ref) {
  var onChange = _ref.onChange,
    value = _ref.value;
  var handleChange = function handleChange(e) {
    if (e.target.value) {
      onChange(e.target.value);
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(Input$1, {
    type: "date",
    onChange: handleChange,
    value: value
  });
});

var DateFilter = (function (_ref) {
  var onChange = _ref.onChange,
    label = _ref.label,
    value = _ref.value;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    alignItems: "baseline",
    padding: "0",
    w: "120px",
    mr: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    bold: true
  }, label), /*#__PURE__*/React__default["default"].createElement(DateInput, {
    onChange: onChange,
    value: value
  }));
});

var DateRangeFilter = function DateRangeFilter(_ref) {
  var onChange = _ref.onChange,
    label = _ref.label,
    defaults = _ref.defaults;
  var _useState = React$1.useState([defaults !== null && defaults !== void 0 && defaults.from ? defaults.from : '', defaults !== null && defaults !== void 0 && defaults.to ? defaults.to : '']),
    _useState2 = _slicedToArray(_useState, 2),
    range = _useState2[0],
    setRange = _useState2[1];
  var handleFrom = function handleFrom(value) {
    var nextRange = value > range[1] ? [range[1], value] : [value, range[1]];
    setRange(nextRange);
    onChange(nextRange);
  };
  var handleTo = function handleTo(value) {
    var nextRange = value < range[0] ? [value, range[0]] : [range[0], value];
    setRange(nextRange);
    onChange(nextRange);
  };
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    alignItems: "center",
    mb: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    alignItems: "baseline",
    padding: "0",
    w: "120px",
    mr: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    bold: true
  }, label), /*#__PURE__*/React__default["default"].createElement(DateInput, {
    onChange: handleFrom,
    value: range[0]
  })), /*#__PURE__*/React__default["default"].createElement(Box, {
    mt: "25px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    bold: true
  }, "TO")), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    alignItems: "baseline",
    padding: "0",
    mt: "25px",
    w: "120px",
    ml: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(DateInput, {
    onChange: handleTo,
    value: range[1]
  })));
};

var Filter = (function (_ref) {
  var label = _ref.label,
    options = _ref.options,
    onChange = _ref.onChange,
    variant = _ref.variant,
    defaults = _ref.defaults;
  var _useState = React$1.useState(null),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    var setValue = _useState2[1];
  var handleChange = function handleChange(e) {
    var nextVal = e.target.value;
    setValue(nextVal);
    onChange(nextVal);
  };
  var Variant;
  switch (variant) {
    default:
      Variant = /*#__PURE__*/React__default["default"].createElement(FlexBox, {
        flexDirection: "column",
        alignItems: "baseline",
        padding: "0",
        minWidth: "200px"
      }, /*#__PURE__*/React__default["default"].createElement(Body, {
        variant: "small",
        bold: true
      }, label), /*#__PURE__*/React__default["default"].createElement(Filter$1, {
        onChange: handleChange,
        value: defaults === null || defaults === void 0 ? void 0 : defaults.value
      }, options === null || options === void 0 ? void 0 : options.map(function (option) {
        return /*#__PURE__*/React__default["default"].createElement("option", {
          key: "opt-".concat(option.value),
          value: option.value
        }, option.label);
      })));
      break;
    case 'date':
      Variant = /*#__PURE__*/React__default["default"].createElement(DateFilter, {
        onChange: onChange,
        label: label,
        value: defaults === null || defaults === void 0 ? void 0 : defaults.value
      });
      break;
    case 'range':
      Variant = /*#__PURE__*/React__default["default"].createElement(RangeFilter, {
        onChange: onChange,
        label: label,
        options: options,
        defaults: defaults
      });
      break;
    case 'dateRange':
      Variant = /*#__PURE__*/React__default["default"].createElement(DateRangeFilter, {
        onChange: onChange,
        label: label,
        defaults: defaults
      });
      break;
  }
  return Variant;
});

var _templateObject$J;
var Link$1 = styled__default["default"].a(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n  font-family: usual;\n  font-size: 14;\n  color: ", ";\n  text-decoration: underline;\n  margin-bottom: 10px;\n  cursor: pointer;\n"])), function (props) {
  return props.dark ? 'white' : props.color || 'black';
});
var ResourceLink = (function (_ref) {
  var dark = _ref.dark,
    color = _ref.color,
    src = _ref.src,
    label = _ref.label;
  return /*#__PURE__*/React.createElement(Link$1, {
    src: src,
    dark: dark,
    color: color
  }, label);
});

var _templateObject$I;
var RowItem$1 = styled__default["default"](FlexBox)(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  justify-content: start; \n\n  &:nth-child(1) {\n    width: 32%;\n  } \n  &:nth-child(2) { \n    width: 32%;\n  }\n  &:nth-child(3) {\n    width: 32%;\n  } \n\n  @media (max-width: 768px) {\n    &:nth-child(1) {\n      width: 100%;\n      padding-left: 0; \n      padding-right: 0; \n      margin-left: 0;\n      margin-right: 0;\n      margin-bottom: 40px;\n    } \n    &:nth-child(2) { \n      width: 100%;\n      padding-left: 0; \n      padding-right: 0; \n      margin-left: 0;\n      margin-right: 0;\n      margin-bottom: 40px;\n    }\n    &:nth-child(3) { \n      width: 100%;\n      padding-left: 0; \n      padding-right: 0; \n      margin-left: 0;\n      margin-right: 0;\n    }\n  }\n"])));
var ThreeColumn = (function (_ref) {
  var children = _ref.children,
    alignItems = _ref.alignItems;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: breakpoint === 'mobile' ? 'column' : 'row',
    justifyContent: breakpoint === 'mobile' ? "center" : "space-evenly",
    alignItems: alignItems || 'flex-start'
  }, React__default["default"].Children.map(children, function (child) {
    return /*#__PURE__*/React__default["default"].createElement(RowItem$1, null, /*#__PURE__*/React__default["default"].cloneElement(child, child.props));
  }));
});

var _templateObject$H;
var RowItem = styled__default["default"](FlexBox)(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n  @media (min-width: 769px) {\n    ", " \n    ", "\n    ", "\n    ", " \n  }\n\n  &:nth-child(1) {\n    padding-right: 24px;\n    justify-content: end; \n  } \n  &:nth-child(2) { \n    padding-left: 24px; \n    justify-content: start; \n  }\n\n  @media (max-width: 768px) {\n    &:nth-child(1) {\n      padding-left: 0; \n      justify-content: start;\n    } \n    &:nth-child(2) { \n      padding-left: 0; \n      justify-content: start;\n    }\n  }\n"])), function (props) {
  return props.variant === 'wide-right' ? '&:nth-child(1) { width: 32%; }; &:nth-child(2) { width: 68% };' : '';
}, function (props) {
  return props.variant === 'wide-left' ? '&:nth-child(2) { width: 32% }; &:nth-child(1) { width: 68% };' : '';
}, function (props) {
  return props.variant === 'xl-left' ? '&:nth-child(2) { width: 18% }; &:nth-child(1) { width: 82% };' : '';
}, function (props) {
  return props.variant === 'xl-right' ? '&:nth-child(1) { width: 18% }; &:nth-child(2) { width: 82% };' : '';
});
var TwoColumn = (function (_ref) {
  var children = _ref.children,
    variant = _ref.variant;
    _ref.padding;
    var alignItems = _ref.alignItems,
    reverse = _ref.reverse,
    backgroundColor = _ref.backgroundColor;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: breakpoint === 'mobile' ? "column".concat(reverse ? '-reverse' : '') : 'row'
    /*
    padding={padding || (breakpoint === 'mobile') ? '0 24px' : '0 48px'}
    mb="40px"
    */,
    alignItems: alignItems || 'flex-start',
    justifyContent: breakpoint === 'mobile' ? "center" : "space-evenly",
    backgroundColor: backgroundColor
  }, React__default["default"].Children.map(children, function (child) {
    return /*#__PURE__*/React__default["default"].createElement(RowItem, {
      variant: variant
    }, /*#__PURE__*/React__default["default"].cloneElement(child, child.props));
  }));
});

var Accordion = function Accordion(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(H4, null, title), children);
};

var _templateObject$G, _templateObject2$w, _templateObject3$l, _templateObject4$f;
var Caret = styled__default["default"](Box)(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  transform: rotate(", ");\n  transition: transform 0.1s;\n  transition-timing-function: ease-in;\n  margin: 0 20px 0 0;\n  ", "\n"])), function (props) {
  return props.width ? props.width : "30px";
}, function (props) {
  return props.width ? props.width : "30px";
}, function (props) {
  return props.open ? "45deg" : 0;
}, function (props) {
  return props.dark ? "\n    background-color: white;\n    mask-image: url(/accordion-caret.svg);\n    mask-repeat: no-repeat;\n    mask-size: contain;\n  " : "\n    background-image: url(/accordion-caret.svg);\n    background-repeat: no-repeat;\n    background-size: contain;\n  ";
});
var Content$2 = styled__default["default"](Box)(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral(["\n  opacity: ", ";\n  transition: opacity 0.1s;\n  transition-timing-function: ease-in;\n"])), function (props) {
  return props.open ? 1 : 0;
});
var Container$u = styled__default["default"](FlexBox)(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n  cursor: pointer;\n  user-select: none;\n  transition: top 0.5s;\n"])));
var MiniHeader = styled__default["default"](FlexBox)(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-family: \"usual\";\n  font-weight: bold;\n  text-transform: uppercase;\n"])));
var AccordionItem = function AccordionItem(_ref) {
  var title = _ref.title,
    variant = _ref.variant,
    dark = _ref.dark,
    children = _ref.children,
    onClick = _ref.onClick,
    startOpen = _ref.startOpen;
  var _useState = React$1.useState(startOpen),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var toggle = function toggle() {
    return setOpen(!open);
  };
  if (variant === "mini") {
    return /*#__PURE__*/React__default["default"].createElement(Container$u, {
      flexDirection: "column",
      margin: "10px 0"
    }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
      onClick: toggle,
      justifyContent: "space-between",
      alignItems: "center",
      w: "100%",
      pl: "24px"
    }, /*#__PURE__*/React__default["default"].createElement(MiniHeader, null, title), /*#__PURE__*/React__default["default"].createElement(Caret, {
      alt: "Open Accordion",
      width: "25px",
      open: open,
      dark: dark
    })), open && /*#__PURE__*/React__default["default"].createElement(Content$2, {
      open: open
    }, children));
  }
  return /*#__PURE__*/React__default["default"].createElement(Container$u, {
    onClick: toggle,
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "space-between",
    alignItems: "center",
    w: "100%",
    pl: "24px"
  }, variant === "mobile-menu" ? /*#__PURE__*/React__default["default"].createElement(H3, {
    color: white,
    dark: dark,
    margin: "10px 0",
    onClick: onClick
  }, title) : /*#__PURE__*/React__default["default"].createElement(H5, {
    color: white,
    dark: dark
  }, title), /*#__PURE__*/React__default["default"].createElement(Caret, {
    alt: "Open Accordion",
    open: open,
    dark: dark
  })), open && /*#__PURE__*/React__default["default"].createElement(Content$2, {
    open: open
  }, children));
};

var _templateObject$F, _templateObject2$v, _templateObject3$k, _templateObject4$e;
var Container$t = styled__default["default"](Box)(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n  padding: 0 12px;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 30px;\n\n  @media (min-width: 1025px) {\n    padding: 0 48px;\n  } \n  @media (max-width: 1024px) {\n    padding: 0 24px;\n  } \n"])));
var CrumbContainer = styled__default["default"](Box)(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\n  width: 100%;\n  border-bottom: 1px solid ", ";\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 10px;\n"])), grey600);
var Link = styled__default["default"](Box)(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin-bottom: 8px;\n"])));
var Label = styled__default["default"](Body)(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral(["\n  margin: 0 7px 0 7px;\n"])));
var Breadcrumbs = (function (_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    navigate = _ref.navigate;
  return /*#__PURE__*/React__default["default"].createElement(Container$t, null, /*#__PURE__*/React__default["default"].createElement(CrumbContainer, null, breadcrumbs.map(function (crumb, i) {
    return /*#__PURE__*/React__default["default"].createElement(Link, {
      onClick: function onClick() {
        return navigate(crumb.url);
      },
      key: crumb.url
    }, /*#__PURE__*/React__default["default"].createElement(Label, {
      variant: "small",
      bold: i !== breadcrumbs.length - 1
    }, crumb.label), i < breadcrumbs.length - 1 && /*#__PURE__*/React__default["default"].createElement(Icon, {
      icon: "caret",
      color: grey400,
      width: "6px",
      height: "14px"
    }));
  })));
});

var _templateObject$E, _templateObject2$u;
var Container$s = styled__default["default"](Box)(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 10px 0;\n  align-items: baseline;\n"])));
var Input = styled__default["default"].input(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n  font-family: 'usual';\n  font-weight: 200;\n  width: 100%;\n  font-style: italic;\n  margin-right: 20px;\n  box-sizing: border-box;\n  padding: 10px;\n  color: ", ";\n  background-color: transparent;\n  border: none;\n  border-bottom: 1px solid ", ";\n\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid ", ";\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n"])), function (props) {
  return props.dark ? 'white' : grey400;
}, function (props) {
  return props.dark ? 'white' : grey400;
}, function (props) {
  return props.dark ? 'white' : red;
}, function (props) {
  return props.dark ? 'white' : grey400;
});
var ButtonInput = (function (_ref) {
  var placeholder = _ref.placeholder,
    label = _ref.label,
    dark = _ref.dark,
    onChange = _ref.onChange,
    onClick = _ref.onClick,
    inputType = _ref.inputType;
  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter') {
      onClick();
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$s, null, /*#__PURE__*/React__default["default"].createElement(Input, {
    onChange: onChange,
    placeholder: placeholder,
    dark: dark,
    type: inputType || 'text',
    onKeyPress: handleKeyPress
  }), /*#__PURE__*/React__default["default"].createElement(Box, null, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "tertiary",
    label: label,
    onClick: onClick,
    dark: dark
  })));
});

var _templateObject$D;
var Container$r = styled__default["default"](Box)(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: ", ";\n  height: 100%;\n"])), function (props) {
  return props.right ? 'flex-end' : 'flex-start';
});
var ContentBlock = (function (_ref) {
  var headline = _ref.headline,
    content = _ref.content,
    action = _ref.action,
    right = _ref.right;
  return /*#__PURE__*/React__default["default"].createElement(Container$r, {
    right: right
  }, headline && headline, content && content, action && action);
});

var _templateObject$C, _templateObject2$t, _templateObject3$j, _templateObject4$d;
var Container$q = styled__default["default"].div(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ", ";\n  width: ", ";\n  padding-left: 0;\n  position: relative;\n"])), function (props) {
  return props.variant === 'horizontal' ? 'row' : 'column';
}, function (props) {
  return props.variant === 'mini' ? '204px' : '100%';
});
var SimplePhoto = styled__default["default"](Box)(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "px;\n"])), function (props) {
  return props.size ? props.size : '204';
}, function (props) {
  return props.size ? props.size : '204';
});
var Photo$3 = styled__default["default"](Box)(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n  margin-bottom: 25px;\n\n  @media (min-width: 1025px) {\n    min-width: ", ";\n    height: ", ";\n  }\n\n  @media (max-width: 1024px) {\n    min-width: ", ";\n    height: ", ";\n  }\n\n  @media (max-width: 768px) {\n    min-width: ", ";\n    height: ", ";\n  }\n\n  ", "\n"])), function (props) {
  return props.variant === 'horizontal' ? '200px' : '100%';
}, function (props) {
  return props.variant === 'horizontal' ? '200px' : '433px';
}, function (props) {
  return props.variant === 'horizontal' ? '145px' : '100%';
}, function (props) {
  return props.variant === 'horizontal' ? '145px' : '300px';
}, function (props) {
  return props.variant === 'horizontal' ? '100px' : '100%';
}, function (props) {
  return props.variant === 'horizontal' ? '100px' : '200px';
}, function (props) {
  return props.variant === 'horizontal' ? 'margin-right: 20px;' : '';
});
var Headline$1 = styled__default["default"](H5)(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral(["\n  margin-top: 12px;\n  margin-bottom: 25px;\n\n  @media (max-width: 768px) {\n    margin-top: 0;\n    margin-bottom: 10px;\n  }\n"])));
var Card$1 = function Card(_ref) {
  var image = _ref.image,
    title = _ref.title,
    caption = _ref.caption;
    _ref.link;
    var tags = _ref.tags;
    _ref.action;
    var variant = _ref.variant,
    center = _ref.center,
    right = _ref.right;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    zoom = _useState2[0],
    setZoom = _useState2[1];
  var handleMouseOver = function handleMouseOver() {
    setZoom(true);
  };
  var handleMouseOut = function handleMouseOut() {
    setZoom(false);
  };
  if (variant === 'mini') {
    return /*#__PURE__*/React__default["default"].createElement(Container$q, {
      variant: variant,
      onMouseEnter: handleMouseOver,
      onMouseLeave: handleMouseOut
    }, /*#__PURE__*/React__default["default"].createElement(SimplePhoto, {
      size: breakpoint === 'mobile' ? '340' : '204'
    }, /*#__PURE__*/React__default["default"].createElement(Image$1, {
      src: image,
      tags: tags,
      square: true,
      zoom: zoom
    })), title && /*#__PURE__*/React__default["default"].createElement(H6, {
      uppercase: true,
      condensed: true,
      center: center,
      right: right,
      dangerouslySetInnerHTML: {
        __html: marked__default["default"].parse(title)
      }
    }), caption && /*#__PURE__*/React__default["default"].createElement(Caption, {
      italic: true,
      center: center,
      right: right
    }, caption));
  }
  return /*#__PURE__*/React__default["default"].createElement(Container$q, {
    variant: variant,
    onMouseEnter: handleMouseOver,
    onMouseLeave: handleMouseOut
  }, /*#__PURE__*/React__default["default"].createElement(Photo$3, {
    variant: variant
  }, /*#__PURE__*/React__default["default"].createElement(Image$1, {
    src: image,
    tags: tags,
    square: true,
    zoom: zoom
  })), /*#__PURE__*/React__default["default"].createElement(ContentBlock, {
    headline: variant === 'horizontal' ? undefined : /*#__PURE__*/React__default["default"].createElement(Caption, null, caption),
    content: /*#__PURE__*/React__default["default"].createElement(Headline$1, null, title)
  }));
};

var _templateObject$B, _templateObject2$s, _templateObject3$i, _templateObject4$c;
var Container$p = styled__default["default"](Box)(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  width: 100%;\n  position: relative;\n\n  @media (min-width: 1025px) {\n    height: 720px;\n  }\n\n  @media (max-width: 1024px) {\n    height: 540px;\n  }\n\n  @media (max-width: 768px) {\n    height: 300px;\n  }\n"])));
styled__default["default"](Box)(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n  width: 100%;\n\n  @media (min-width: 1025px) {\n    height: 720px;\n  }\n\n  @media (max-width: 1024px) {\n    height: 540px;\n  }\n\n  @media (max-width: 768px) {\n    height: 300px;\n  }\n"])));
var Content$1 = styled__default["default"](Box)(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral(["\n  padding: 20px;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 5;\n\n  @media(min-width: 1025px) {\n    height: 720px;\n  }\n\n  @media (max-width: 1024px) {\n    height: 540px;\n  }\n\n  @media (max-width: 768px) {\n    height: 300px;\n  }\n"])));
var Info = styled__default["default"](Box)(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  bottom: 20px;\n"])));
var CarouselItem = (function (_ref) {
  var image = _ref.image,
    tag = _ref.tag,
    title = _ref.title;
  return /*#__PURE__*/React__default["default"].createElement(Container$p, null, /*#__PURE__*/React__default["default"].createElement(Image$1, {
    src: image
  }), /*#__PURE__*/React__default["default"].createElement(Content$1, null, /*#__PURE__*/React__default["default"].createElement(Info, null, tag && /*#__PURE__*/React__default["default"].createElement(Tag$1, {
    label: tag
  }), /*#__PURE__*/React__default["default"].createElement(H3, {
    dark: true
  }, title))));
});

var _templateObject$A, _templateObject2$r;
var ConstituentBox = styled__default["default"](FlexBox)(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n    margin-bottom: 10px;\n"])));
var ClickBox = styled__default["default"](Box)(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n    text-decoration: ", ";\n    cursor: ", ";\n"])), function (props) {
  return props.onClick ? 'underline' : '';
}, function (props) {
  return props.onClick ? 'pointer' : '';
});
var CollectionConstituent = (function (_ref) {
  var name = _ref.name,
    nationality = _ref.nationality,
    onClick = _ref.onClick,
    role = _ref.role,
    yearEnd = _ref.yearEnd,
    yearStart = _ref.yearStart;
  return /*#__PURE__*/React__default["default"].createElement(ConstituentBox, {
    flexDirection: "column",
    alignItems: "baseline"
  }, /*#__PURE__*/React__default["default"].createElement(Box, null, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    italic: true
  }, role)), /*#__PURE__*/React__default["default"].createElement(ClickBox, {
    onClick: onClick
  }, /*#__PURE__*/React__default["default"].createElement(Body, null, name)), /*#__PURE__*/React__default["default"].createElement(Box, null, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small"
  }, nationality, nationality && (yearStart && yearStart !== '0' || yearEnd && yearEnd !== '0') && ', ', yearStart && yearStart !== '0' && "".concat(yearStart, " - "), yearEnd && yearEnd !== '0' && yearEnd)));
});

var _templateObject$z, _templateObject2$q, _templateObject3$h, _templateObject4$b, _templateObject5$5;
var CollectionWrapper = styled__default["default"](FlexBox)(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  position: ", ";\n  ", ";\n  ", ";\n  ", ";\n  /* ", "; */\n  z-index: 2000;\n  transition: all .3s;\n"])), function (props) {
  return props.mobile && 'fixed';
}, function (props) {
  return props.mobile && "".concat(props.open ? 'top:0' : 'top: calc(100vh - 60px)');
}, function (props) {
  return props.mobile && 'left: 0';
}, function (props) {
  return props.mobile && "width: 100%";
}, function (props) {
  return props.mobile && "margin-right: 48px";
});
var FilterSectionWrapper = styled__default["default"](FlexBox)(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (props) {
  return props.mobile && "overflow: scroll";
}, function (props) {
  return props.mobile && "min-height: 100vh";
}, function (props) {
  return props.mobile && "overflow-x: hidden";
}, function (props) {
  return props.mobile && "max-height: 100vh";
});
var ViewAllButton = styled__default["default"](FlexBox)(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-family: \"usual\";\n  text-decoration: underline;\n  margin: 10px 0;\n  color: ", ";\n"])), red);
var ExpandableContainer = function ExpandableContainer(_ref) {
  var children = _ref.children,
    filterLimit = _ref.filterLimit;
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var limitChildren = open ? children : children.slice(0, filterLimit);
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    margin: "0 0 0 25px",
    flexDirection: "column"
  }, limitChildren, children.length > filterLimit && /*#__PURE__*/React__default["default"].createElement(ViewAllButton, {
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, open ? "View Less" : "View All"));
};
var Option = styled__default["default"].label(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-family: \"usual\";\n  margin-left: 5px;\n"])));
var Header = styled__default["default"](FlexBox)(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: bold;\n  font-family: \"usual\";\n  color: #fff;\n  padding: 0 20px;\n"])));
var CollectionHeader = function CollectionHeader(_ref2) {
  var mobile = _ref2.mobile,
    setOpen = _ref2.setOpen,
    open = _ref2.open;
  if (mobile) {
    return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
      backgroundColor: red,
      padding: "20px",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      onClick: function onClick() {
        return setOpen(!open);
      }
    }, /*#__PURE__*/React__default["default"].createElement(Header, null, "Collection Filters"), open ? /*#__PURE__*/React__default["default"].createElement(Box, {
      padding: "0 25px 0 0"
    }, /*#__PURE__*/React__default["default"].createElement(SvgHide, null)) : /*#__PURE__*/React__default["default"].createElement(Box, {
      padding: "0 25px 0 0"
    }, /*#__PURE__*/React__default["default"].createElement(SvgShow, null)));
  }
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    backgroundColor: red,
    padding: "10px",
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(Header, null, "Collection Filters"));
};
var CollectionFilters = (function (_ref3) {
  var filters = _ref3.filters;
    _ref3.onClear;
    var _onChange = _ref3.onChange,
    filterLimit = _ref3.filterLimit;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var _useState3 = React$1.useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var isMobile = breakpoint === 'mobile' || breakpoint === 'tabletSmall' || breakpoint === 'tablet';
  return /*#__PURE__*/React__default["default"].createElement(CollectionWrapper, {
    flexDirection: "column",
    w: "400px",
    mobile: isMobile,
    open: open
  }, /*#__PURE__*/React__default["default"].createElement(CollectionHeader, {
    mobile: isMobile,
    setOpen: setOpen,
    open: open
  }), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    backgroundColor: grey600,
    flexDirection: "column",
    padding: "0 10px"
  }, /*#__PURE__*/React__default["default"].createElement(FilterSectionWrapper, {
    flexDirection: "column",
    mobile: isMobile,
    backgroundColor: grey600
  }, Object.keys(filters).map(function (filterSet, oi) {
    var filterArray = filters[filterSet].options;
    return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
      flexDirection: "column",
      key: oi
    }, /*#__PURE__*/React__default["default"].createElement(AccordionItem, {
      title: filters[filterSet].label,
      variant: "mini",
      startOpen: true
    }, /*#__PURE__*/React__default["default"].createElement(ExpandableContainer, {
      filterLimit: filterLimit
    }, Object.keys(filterArray).map(function (ob, ii) {
      var option = filterArray[ob];
      return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
        key: ii
      }, /*#__PURE__*/React__default["default"].createElement("input", {
        type: "checkbox",
        defaultChecked: option.selected,
        onChange: function onChange() {
          return _onChange({
            filter: filterSet,
            item: ob
          });
        },
        id: "".concat(option.label, "(").concat(oi, ")(").concat(ii, ")")
      }), /*#__PURE__*/React__default["default"].createElement(Option, {
        htmlFor: "".concat(option.label, "(").concat(ii, ")")
      }, "".concat(ob, " (").concat(option.count, ")")));
    }))), /*#__PURE__*/React__default["default"].createElement(Divider$1, {
      color: grey800,
      margin: "0"
    }));
  }))));
});

var _templateObject$y, _templateObject2$p;
var Title$1 = styled__default["default"](Body)(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  color: ", ";\n"])), grey400);
var Container$o = styled__default["default"](FlexBox)(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n  border-bottom: 1px solid ", ";\n"])), grey600);
var DetailSidebarSection = (function (_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(Container$o, {
    flexDirection: "column",
    padding: "10px 0"
  }, /*#__PURE__*/React__default["default"].createElement(Title$1, {
    variant: "small",
    bold: true
  }, title), children);
});

var ContactSidebarItem = (function (_ref) {
  var name = _ref.name,
    email = _ref.email,
    phone = _ref.phone,
    organization = _ref.organization,
    action = _ref.action,
    actionLabel = _ref.actionLabel;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    color: grey400
  }, name), organization && /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    color: grey400
  }, organization), phone && /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    color: grey400
  }, phone), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "text",
    color: red,
    onClick: action(email),
    label: actionLabel
  }));
});

var ContactSidebarSection = (function (_ref) {
  var contacts = _ref.contacts,
    title = _ref.title;
  return /*#__PURE__*/React__default["default"].createElement(DetailSidebarSection, {
    title: title
  }, contacts.map(function (c, i) {
    return /*#__PURE__*/React__default["default"].createElement(ContactSidebarItem, _extends({
      key: i
    }, c));
  }));
});

var FilterBar = (function (_ref) {
  _ref.onChange;
    var onSearch = _ref.onSearch,
    searchLabel = _ref.searchLabel,
    children = _ref.children,
    value = _ref.value;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var _useState = React$1.useState({}),
    _useState2 = _slicedToArray(_useState, 2);
    _useState2[0];
    _useState2[1];
  var _useState3 = React$1.useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchTerm = _useState4[0],
    setSearchTerm = _useState4[1];
  var handleSearch = function handleSearch() {
    return onSearch(searchTerm);
  };
  var handleSearchChange = function handleSearchChange(e) {
    return setSearchTerm(e.target.value);
  };
  var placeHolder = value ? value : "Enter search text";
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: breakpoint === 'mobile' ? 'column' : 'row',
    alignItems: 'flex-start',
    justifyContent: breakpoint === 'mobile' ? "center" : "space-between"
  }, children, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    mb: "-30px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    bold: true,
    variant: "small"
  }, searchLabel || 'Search'), /*#__PURE__*/React__default["default"].createElement(ButtonInput, {
    placeholder: placeHolder,
    label: "Search",
    onClick: handleSearch,
    onChange: handleSearchChange
  })));
});

var filters$1 = [{
  name: 'date',
  label: 'Date Range',
  variant: 'dateRange',
  defaults: {
    from: dateFns.format(new Date(), 'yyyy-MM-dd'),
    to: dateFns.format(dateFns.addDays(new Date(), 30), 'yyyy-MM-dd')
  }
}, {
  name: 'audiences',
  label: 'Audiences',
  options: [{
    label: 'All Audiences',
    value: '*'
  }, {
    label: 'Some Audiences',
    value: 'some'
  }]
}, {
  name: 'category',
  label: 'Category',
  options: [{
    label: 'All Categories',
    value: '*'
  }, {
    label: 'Some Categories',
    value: 100
  }]
}, {
  name: 'location',
  label: 'Location',
  options: [{
    label: 'All Locations',
    value: '*'
  }, {
    label: 'Some Locations',
    value: 100
  }]
}, {
  name: 'price',
  label: 'Price',
  options: [{
    label: 'All Prices',
    value: '*'
  }, {
    label: 'Some Prices',
    value: 100
  }]
}];
var EventFilters = (function (_ref) {
  var onChange = _ref.onChange,
    onSearch = _ref.onSearch;
  return /*#__PURE__*/React__default["default"].createElement(FilterBar, {
    searchLabel: "Search all Events",
    filters: filters$1,
    onChange: onChange,
    onSearch: onSearch
  });
});

var year = new Date().getYear() + 1900;
var yearOptions = [];
for (var i = 1905; i <= year + 1; i += 1) {
  yearOptions.push({
    label: i.toString(),
    value: i
  });
}
var defaultFilters = [{
  name: 'type',
  label: 'Type',
  options: [{
    label: 'All Exhibitions',
    value: 'all'
  }, {
    label: 'Current Exhibitions',
    value: 'current'
  }, {
    label: 'Upcoming Exhibitions',
    value: 'upcoming'
  }, {
    label: 'Past Exhibitions',
    value: 'past'
  }]
}, {
  name: 'date',
  label: 'Date Range',
  variant: 'range',
  options: yearOptions,
  defaults: {
    from: year,
    to: year + 1
  }
}];
var ExhibitionFilters = (function (_ref) {
  var filters = _ref.filters,
    onChange = _ref.onChange,
    onSearch = _ref.onSearch;
  return /*#__PURE__*/React__default["default"].createElement(FilterBar, {
    searchLabel: "Search all Exhibitions",
    filters: filters || defaultFilters,
    onChange: onChange,
    onSearch: onSearch
  });
});

var _templateObject$x;
var EyebrowContainer = styled__default["default"](FlexBox)(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n  padding: 4px;\n  align-items: left;\n  text-align: left;\n  height: 50px;\n  margin-bottom: 10px;\n"])));
var Eyebrow = (function (_ref) {
  var body = _ref.body,
    link = _ref.link,
    linktext = _ref.linktext;
    _ref.mobile;
    var navigate = _ref.navigate,
    theme = _ref.theme;
  var background = black;
  var color = white;
  var linkBackground = white;
  var linkColor = grey400;
  switch (theme) {
    case 'red':
      background = red;
      linkBackground = magenta;
      linkColor = black;
      break;
    case 'green':
      background = green;
      color = black;
      linkBackground = limeGreen;
      break;
    case 'purple':
      background = purple;
      linkBackground = white;
      linkColor = purple;
      break;
    case 'teal':
      background = teal;
      linkBackground = darkTeal;
      linkColor = white;
      break;
  }
  return /*#__PURE__*/React__default["default"].createElement(EyebrowContainer, {
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: background,
    color: color
  }, /*#__PURE__*/React__default["default"].createElement(Box, {
    w: "210px",
    ml: "6px",
    mr: "3px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    color: color,
    bold: true,
    variant: "small"
  }, body)), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    ml: "3px",
    mr: "6px",
    justifyContent: "flex-end",
    backgroundColor: green
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    color: linkColor,
    background: linkBackground,
    label: linktext,
    onClick: navigate(link),
    variant: "eyebrow"
  })));
});

var _templateObject$w;
var ActionBox$1 = styled__default["default"](Box)(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  background-color: ", ";\n  @media (min-width: 601px) {\n    max-width: 400px;\n  }\n  @media (max-width: 600px) {\n    padding-top: 50px;\n  }\n"])), function (props) {
  return props.color;
});
var HeroActionBox = function HeroActionBox(_ref) {
  var headline = _ref.headline,
    description = _ref.description,
    action = _ref.action,
    actionLabel = _ref.actionLabel,
    color = _ref.color,
    dark = _ref.dark;
  return /*#__PURE__*/React__default["default"].createElement(ActionBox$1, {
    color: color,
    padding: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(ContentBlock, {
    headline: /*#__PURE__*/React__default["default"].createElement(H3, {
      color: dark ? white : grey200
    }, headline),
    content: /*#__PURE__*/React__default["default"].createElement(Box, {
      mb: "20px"
    }, /*#__PURE__*/React__default["default"].createElement(Body, {
      large: true,
      color: dark ? white : grey200
    }, description)),
    action: /*#__PURE__*/React__default["default"].createElement(Button, {
      onClick: action,
      color: dark ? white : grey200,
      label: actionLabel
    })
  }));
};

var _templateObject$v, _templateObject2$o, _templateObject3$g, _templateObject4$a;
var Photo$2 = styled__default["default"](Box)(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n  position: relative;\n\n  @media (min-width: 1025px) {\n    z-index: 1;\n    height: 540px;\n    width: calc(100% - 25px);\n    margin-left: ", ";\n  }\n\n  @media (max-width: 1024px) {\n    z-index: 1;\n    height: 391px;\n    width: calc(100% - 25px);\n    margin-left: ", ";\n  }\n\n  @media (max-width: 600px) {\n    z-index: 2;\n    height: 130px;\n    width: calc(100% - 60px);\n    margin-left: 30px;\n  }\n"])), function (props) {
  return props.right ? '25px' : '0';
}, function (props) {
  return props.right ? '25px' : '0';
});
var ActionBox = styled__default["default"](Box)(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n  position: relative;\n\n  @media (min-width: 601px) {\n    z-index: 2;\n    ", "\n  }\n\n  @media (min-width: 1025px) {\n    width: 400px;\n    margin-top: -230px;\n  }\n\n  @media (max-width: 1024px) {\n    width: 350px;\n    margin-top: -220px;\n  }\n\n  @media (max-width: 600px) {\n    z-index: 1;\n    width: 100%;\n    padding-top: 80px;\n    margin-top: -130px;\n  }\n"])), function (props) {
  return props.right ? '' : 'float: right;';
});
var Container$n = styled__default["default"](Box)(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  justify-content: ", ";\n"])), function (props) {
  return props.right ? 'end' : 'start';
});
var Shifter = styled__default["default"](Box)(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var JourneylineHero = function JourneylineHero(_ref) {
  var right = _ref.right,
    image = _ref.image,
    headline = _ref.headline,
    description = _ref.description,
    action = _ref.action,
    actionLabel = _ref.actionLabel,
    color = _ref.color,
    dark = _ref.dark;
  return /*#__PURE__*/React__default["default"].createElement(Container$n, {
    right: right
  }, /*#__PURE__*/React__default["default"].createElement(Shifter, null, /*#__PURE__*/React__default["default"].createElement(Photo$2, {
    right: right
  }, /*#__PURE__*/React__default["default"].createElement(Image$1, {
    src: image
  })), /*#__PURE__*/React__default["default"].createElement(ActionBox, {
    right: right
  }, /*#__PURE__*/React__default["default"].createElement(HeroActionBox, {
    headline: headline,
    description: description,
    color: color,
    action: action,
    actionLabel: actionLabel,
    dark: dark
  }))));
};

var _templateObject$u, _templateObject2$n, _templateObject3$f, _templateObject4$9, _templateObject5$4, _templateObject6$2, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1;
var Container$m = styled__default["default"](Box)(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: visible;\n\n  @media (max-width: 768px) {\n    overflow-y: visible;\n    overflow-x: hidden;\n  }\n"])));
var Controls$1 = styled__default["default"](Box)(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  z-index: 99;\n\n  @media (min-width: 1025px) {\n    top: 250px;\n    left: ", ";\n    right: ", ";\n  }\n\n  @media (max-width: 1024px) {\n    top: 200px;\n    left: ", ";\n    right: ", ";\n  }\n\n  @media (max-width: 768px) {\n    top: 340px;\n    left: ", ";\n    right: ", ";\n  }\n"])), function (props) {
  return props.left ? '20px' : 'auto';
}, function (props) {
  return props.right ? '20px' : 'auto';
}, function (props) {
  return props.left ? '10px' : 'auto';
}, function (props) {
  return props.right ? '10px' : 'auto';
}, function (props) {
  return props.left ? '10px' : 'auto';
}, function (props) {
  return props.right ? '10px' : 'auto';
});
var VideoHero$1 = styled__default["default"](Box)(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n  @media (min-width: 1025px) {\n    height: 1000px;\n  }\n  @media (max-width: 1024px) {\n    height: 725px;\n  }\n  @media (max-width: 768px) {\n    height: 475px;\n  }\n  width: 100%;\n  z-index: 1;\n  overflow: hidden;\n  background-color: ", ";\n"])), grey500);
var VideoComponent$1 = styled__default["default"].video(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n  min-width: 100%;\n  min-height: 100%;\n  max-height: 1000px;\n  width: auto;\n  height: auto;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])));
var VideoContent = styled__default["default"](Box)(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n  z-index: 2;\n  position: absolute;\n  width: 450px;\n\n  @media (min-width: 1025px) {\n    left: 48px;\n    top: 300px;\n  }\n\n  @media (max-width: 1024px) {\n    left: 24px;\n    top: 200px;\n  }\n\n  @media (max-width: 768px) {\n    top: 100px;\n    width: 90%;\n  }\n"])));
styled__default["default"](H6)(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n  padding-bottom: 20px;\n"])));
var ImageHero = styled__default["default"](Box)(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  @media (min-width: 1025px) {\n    height: 500px;\n  }\n  @media (max-width: 1024px) {\n    height: 450px;\n  }\n  @media (max-width: 768px) {\n    height: 400px;\n  }\n  width: 100%;\n  z-index: 1;\n  overflow: hidden;\n  background-color: ", ";\n"])), grey500);
styled__default["default"](Box)(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  z-index: 2;\n  position: absolute;\n  width: 450px;\n\n  @media (min-width: 1025px) {\n    left: 68px;\n    top: 30px;\n  }\n\n  @media (max-width: 1024px) {\n    left: 54px;\n    top: 20px;\n  }\n\n  @media (max-width: 768px) {\n    left: 20px;\n    top: 10px;\n    width: 90%;\n  }\n"])));
styled__default["default"](Button)(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  z-index: 5;\n"])));
var Journeyline$1 = styled__default["default"](Box)(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n\n  background-image: url(/journeyline-primary-down.svg);\n  background-repeat: no-repeat;\n\n  @media (min-width: 1025px) {\n    height: 170px;\n    bottom: -74px;\n  }\n\n  @media (max-width: 1024px) {\n    height: 100px;\n    background-position: 100% 0;\n    bottom: -54px;\n  }\n"])));
var HomepageHero = (function (_ref) {
  var lightHeadline = _ref.lightHeadline,
    boldHeadline = _ref.boldHeadline,
    description = _ref.description,
    action = _ref.action,
    actionLabel = _ref.actionLabel,
    desktop = _ref.desktop,
    tablet = _ref.tablet,
    mobile = _ref.mobile,
    textcolor = _ref.textcolor,
    dark = _ref.dark,
    prev = _ref.prev,
    next = _ref.next;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var getTextColor = function getTextColor() {
    if (textcolor) {
      return textcolor;
    } else {
      return 'white';
    }
  };
  var getMediaType = function getMediaType() {
    if (desktop.includes('.mp4')) {
      return 'video';
    } else {
      return 'image';
    }
  };
  var getVideoSource = function getVideoSource() {
    switch (breakpoint) {
      case "mobile":
        return mobile;
      case "tablet":
      case "tabletSmall":
        return tablet;
      default:
        return desktop;
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$m, null, getMediaType() === 'video' ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(VideoHero$1, null, /*#__PURE__*/React__default["default"].createElement(VideoComponent$1, {
    src: getVideoSource(),
    muted: true,
    loop: true,
    autoPlay: true,
    playsInline: true
  })), /*#__PURE__*/React__default["default"].createElement(VideoContent, null, /*#__PURE__*/React__default["default"].createElement(ContentBlock, {
    headline: /*#__PURE__*/React__default["default"].createElement(HeroHeader, {
      dark: dark,
      color: getTextColor(),
      lightText: lightHeadline,
      boldText: boldHeadline
    }),
    content: /*#__PURE__*/React__default["default"].createElement(H5, {
      dark: dark,
      color: getTextColor()
    }, description),
    action: /*#__PURE__*/React__default["default"].createElement(Button, {
      color: red,
      variant: "primary",
      onClick: action,
      label: actionLabel
    })
  })), /*#__PURE__*/React__default["default"].createElement(Controls$1, {
    left: true
  }, prev && /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "left",
    color: red,
    background: white,
    onClick: prev,
    width: 29,
    height: 40,
    padding: "2px"
  })), /*#__PURE__*/React__default["default"].createElement(Controls$1, {
    right: true
  }, next && /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "right",
    color: red,
    background: white,
    onClick: next,
    width: 29,
    height: 40,
    padding: "2px"
  }))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(ImageHero, null, /*#__PURE__*/React__default["default"].createElement(Image$1, {
    onclick: action,
    src: getVideoSource(),
    alt: actionLabel
  })), /*#__PURE__*/React__default["default"].createElement(Controls$1, {
    left: true
  }, prev && /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "left",
    color: red,
    background: white,
    onClick: prev,
    width: 29,
    height: 40,
    padding: "2px"
  })), /*#__PURE__*/React__default["default"].createElement(Controls$1, {
    right: true
  }, next && /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "right",
    color: red,
    background: white,
    onClick: next,
    width: 29,
    height: 40,
    padding: "2px"
  }))), breakpoint !== 'mobile' && /*#__PURE__*/React__default["default"].createElement(Journeyline$1, null));
});

var _templateObject$t, _templateObject2$m;
var Container$l = styled__default["default"].div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: flex-start;\n  align-items: start;\n\n  @media (min-width: 1025px) {\n    width: 700px;\n  }\n\n  @media (max-width: 1024px) {\n    width: 600px;\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n"])));
var LightHead = styled__default["default"](Box)(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n  width: fit-content;\n  white-space: nowrap;\n"])));
var HomepageSectionHeader = (function (_ref) {
  var boldHeadline = _ref.boldHeadline,
    lightHeadline = _ref.lightHeadline,
    description = _ref.description,
    action = _ref.action,
    actionLabel = _ref.actionLabel;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var headline = breakpoint === 'mobile' ? /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(H1, {
    margin: "0"
  }, boldHeadline), /*#__PURE__*/React__default["default"].createElement(H1, {
    light: true,
    margin: "0"
  }, lightHeadline)) : /*#__PURE__*/React__default["default"].createElement(H1, {
    margin: "12px"
  }, boldHeadline);
  return /*#__PURE__*/React__default["default"].createElement(Container$l, null, breakpoint !== 'mobile' && /*#__PURE__*/React__default["default"].createElement(LightHead, null, /*#__PURE__*/React__default["default"].createElement(H1, {
    light: true,
    margin: "12px 0"
  }, lightHeadline)), /*#__PURE__*/React__default["default"].createElement(Box, {
    mr: "10px",
    padding: breakpoint === 'mobile' ? '12px' : '0'
  }, /*#__PURE__*/React__default["default"].createElement(ContentBlock, {
    right: breakpoint !== 'mobile',
    headline: headline,
    content: /*#__PURE__*/React__default["default"].createElement(H5, {
      right: breakpoint !== 'mobile',
      margin: "5px 0 20px 0"
    }, description),
    action: action && /*#__PURE__*/React__default["default"].createElement(Button, {
      compact: true,
      color: red,
      onClick: action,
      label: actionLabel
    })
  })));
});

var _templateObject$s, _templateObject2$l, _templateObject3$e, _templateObject4$8;
var Photo$1 = styled__default["default"](Box)(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 10px;\n\n  @media (max-width: 480px) {\n    height: ", ";\n  }\n\n  @media (min-width: 481px) {\n    height: ", ";\n  }\n"])), function (props) {
  return props.tall ? '360px' : '120px';
}, function (props) {
  return props.tall ? '500px' : '140px';
});
var Container$k = styled__default["default"](Box)(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n  position: relative;\n\n  margin-top: 20px;\n\n  @media(max-width: 480px) {\n    margin-top: 10px;\n    border-bottom: 15px solid ", ";\n  }\n\n  @media(min-width: 481px) {\n    margin-top: 20px;\n    border-bottom: 20px solid ", ";\n  }\n  \n  width: 100%;\n  margin-bottom: 40px;\n"])), red, red);
var Quote = styled__default["default"].div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n  position: relative;\n  bottom: 0;\n  float: right;\n  margin-bottom: -69px;\n"])));
var Title = styled__default["default"](H3)(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 300px;\n  z-index: 998;\n  color: white;\n  max-width: 70%;\n  padding: 0 48px;\n"])));
var JourneylineHeader = function JourneylineHeader(_ref) {
  var desktopSrc = _ref.desktopSrc,
    tabletSrc = _ref.tabletSrc,
    mobileSrc = _ref.mobileSrc,
    title = _ref.title;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var image;
  switch (breakpoint) {
    case 'desktop':
    default:
      image = desktopSrc || tabletSrc || mobileSrc;
      break;
    case 'tablet':
    case 'tabletSmall':
      image = tabletSrc || desktopSrc || mobileSrc;
      break;
    case 'mobile':
      image = mobileSrc || tabletSrc || desktopSrc;
      break;
  }
  return /*#__PURE__*/React__default["default"].createElement(Container$k, null, (image || title) && /*#__PURE__*/React__default["default"].createElement(Photo$1, {
    tall: title !== null && title !== undefined
  }, title && /*#__PURE__*/React__default["default"].createElement(Title, null, title), image && /*#__PURE__*/React__default["default"].createElement(Image$1, {
    src: image
  })), /*#__PURE__*/React__default["default"].createElement(Quote, null, breakpoint === 'mobile' ? /*#__PURE__*/React__default["default"].createElement(SvgHeadingQuoteRightMobile, null) : /*#__PURE__*/React__default["default"].createElement(SvgHeadingQuoteRight, null)));
};

var _templateObject$r;
var Container$j = styled__default["default"](Box)(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n  padding: 0 12px;\n\n  @media (min-width: 1025px) {\n    padding: 0 48px;\n  } \n  @media (max-width: 1024px) {\n    padding: 0 24px;\n  } \n\n  max-width: 1000px;\n  margin-bottom: 20px;\n  & h2 {\n    margin: 5px 0;\n  }\n  & h5 {\n    margin: 5px 0;\n  }\n  text-align: ", ";\n"])), function (props) {
  return props.align ? props.align : 'left';
});
var PageHeadline = (function (_ref) {
  var headline = _ref.headline,
    caption = _ref.caption,
    align = _ref.align;
  return /*#__PURE__*/React__default["default"].createElement(Container$j, {
    align: align
  }, /*#__PURE__*/React__default["default"].createElement(H2, null, headline), caption && /*#__PURE__*/React__default["default"].createElement(H5, {
    color: grey400
  }, caption));
});

var Pagination = (function (_ref) {
  var currentPage = _ref.currentPage,
    pageCount = _ref.pageCount,
    onChange = _ref.onChange;
  var _useState = React$1.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    jumpPage = _useState2[0],
    setJumpPage = _useState2[1];

  // Not typescript, so let's make sure its a number
  var thisPage = parseInt(currentPage);
  var prevPage = function prevPage() {
    return onChange(thisPage - 1 < 1 ? 1 : thisPage - 1);
  };
  var nextPage = function nextPage() {
    return onChange(thisPage + 1 > pageCount ? pageCount : thisPage + 1);
  };
  var goToPage = function goToPage(num) {
    return function () {
      return onChange(parseInt(num) < 1 ? 1 : parseInt(num) > pageCount ? pageCount : parseInt(num));
    };
  };
  var handleChange = function handleChange(e) {
    return setJumpPage(parseInt(e.target.value) < 1 ? 1 : parseInt(e.target.value) > pageCount ? pageCount : parseInt(e.target.value));
  };
  var ellipsis = 0;
  var getLink = function getLink(page) {
    if (page === thisPage) {
      return /*#__PURE__*/React__default["default"].createElement(Body, {
        bold: true,
        variant: "large",
        color: grey400,
        key: "link-".concat(page)
      }, page);
    } else if (page === '...') {
      ellipsis++;
      return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
        alignItems: "center",
        justifyContent: "space-between",
        key: "ellipsis-".concat(ellipsis)
      }, /*#__PURE__*/React__default["default"].createElement(Box, {
        mr: "10px"
      }, /*#__PURE__*/React__default["default"].createElement(Body, {
        color: grey200
      }, "...")));
    } else {
      return /*#__PURE__*/React__default["default"].createElement(Button, {
        variant: "text",
        color: red,
        onClick: goToPage(page),
        label: page,
        key: "link-".concat(page)
      });
    }
  };
  var links = [];
  if (pageCount <= 7) {
    for (var i = 1; i <= pageCount; i += 1) {
      links.push(getLink(i));
    }
  } else {
    if (thisPage >= 5 && thisPage <= pageCount - 5) {
      links.push(getLink(1));
      links.push(getLink('...'));
      var start = thisPage - 2;
      for (var _i = 0; _i <= 4; _i += 1) {
        links.push(getLink(start + _i));
      }
      links.push(getLink('...'));
      links.push(getLink(pageCount));
    } else if (thisPage < 5) {
      for (var _i2 = 1; _i2 <= 5; _i2 += 1) {
        links.push(getLink(_i2));
      }
      links.push(getLink('...'));
      links.push(getLink(pageCount));
    } else if (thisPage > pageCount - 5) {
      links.push(getLink(1));
      links.push(getLink('...'));
      for (var _i3 = pageCount - 4; _i3 <= pageCount; _i3 += 1) {
        links.push(getLink(_i3));
      }
    }
  }
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "center",
    w: "100%"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    alignItems: "center",
    justifyContent: "space-between",
    w: "100%"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    dark: true,
    variant: "icon",
    icon: "left",
    color: red,
    onClick: prevPage,
    disabled: thisPage === 1,
    width: "24",
    height: "38"
  }), links, /*#__PURE__*/React__default["default"].createElement(Button, {
    dark: true,
    variant: "icon",
    icon: "right",
    color: red,
    onClick: nextPage,
    disabled: thisPage === pageCount,
    width: "26",
    height: "38"
  }), pageCount > 10 && /*#__PURE__*/React__default["default"].createElement(Box, {
    w: "155px"
  }, /*#__PURE__*/React__default["default"].createElement(ButtonInput, {
    label: "Go",
    placeholder: "Go to page",
    onChange: handleChange,
    onClick: goToPage(jumpPage),
    inputType: "number"
  }))));
});

var filters = [{
  name: 'language',
  label: 'Language',
  options: [{
    label: 'English',
    value: 'en'
  }, {
    label: 'Spanish',
    value: 'es'
  }]
}, {
  name: 'category',
  label: 'Category',
  options: [{
    label: 'All Categories',
    value: '*'
  }, {
    label: 'Some Categories',
    value: 100
  }]
}, {
  name: 'date',
  label: 'Date Posted',
  variant: 'range',
  options: [{
    label: '2000',
    value: 2000
  }, {
    label: '2022',
    value: 2022
  }]
}];
var PressFilters = (function (_ref) {
  var onChange = _ref.onChange,
    onSearch = _ref.onSearch;
  return /*#__PURE__*/React__default["default"].createElement(FilterBar, {
    searchLabel: "Search all Articles",
    filters: filters,
    onChange: onChange,
    onSearch: onSearch
  });
});

var PressInquiriesSection = (function (_ref) {
  var headline = _ref.headline,
    resourceHeadline = _ref.resourceHeadline,
    resourceLinks = _ref.resourceLinks,
    actionLabel = _ref.actionLabel,
    contactName = _ref.contactName,
    contactTitle = _ref.contactTitle,
    contactPhone = _ref.contactPhone;
  return /*#__PURE__*/React__default["default"].createElement(JourneylineCalloutSection, {
    color: purple
  }, /*#__PURE__*/React__default["default"].createElement(TwoColumn, {
    variant: "wide-right"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    mb: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(H5, {
    color: "white",
    margin: "20px 0"
  }, headline), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    mb: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    bold: true,
    color: "white"
  }, contactName), /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    color: "white"
  }, contactTitle), /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    color: "white"
  }, contactPhone)), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "tertiary",
    color: "white",
    label: actionLabel
  })), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(H5, {
    color: "white",
    margin: "20px 0"
  }, resourceHeadline), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    maxHeight: "140px",
    flexWrap: "wrap"
  }, resourceLinks.map(function (resource) {
    return /*#__PURE__*/React__default["default"].createElement(ResourceLink, _extends({
      dark: true
    }, resource));
  })))));
});

var _templateObject$q, _templateObject2$k, _templateObject3$d, _templateObject4$7, _templateObject5$3, _templateObject6$1;
var Container$i = styled__default["default"].div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-left: 0;\n  position: relative;\n"])));
var Photo = styled__default["default"](Box)(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n  margin-bottom: 25px;\n  width: 100%;\n  height: 318px;\n"])));
var Headline = styled__default["default"](Body)(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n  width: 75%;\n  margin-top: 12px;\n  margin-bottom: 25px;\n  text-transform: uppercase;\n"])));
var Price = styled__default["default"](Body)(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n  width: 25%;\n  text-align: right;\n"])));
var HeadlineRow = styled__default["default"].div(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  width: 100%;\n  margin-top: -20px;\n"])));
var TagRow = styled__default["default"].div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  top: 11px;\n  right: 11px;\n"])));
var Card = function Card(_ref) {
  var image = _ref.image,
    title = _ref.title,
    price = _ref.price;
    _ref.link;
    var dark = _ref.dark,
    tags = _ref.tags;
  return /*#__PURE__*/React.createElement(Container$i, null, /*#__PURE__*/React.createElement(Photo, null, /*#__PURE__*/React.createElement(Image$1, {
    src: image,
    square: true
  })), (tags === null || tags === void 0 ? void 0 : tags.length) > 0 && /*#__PURE__*/React.createElement(TagRow, null, tags.map(function (t) {
    return /*#__PURE__*/React.createElement(Tag$1, t);
  })), /*#__PURE__*/React.createElement(HeadlineRow, null, /*#__PURE__*/React.createElement(Headline, {
    bold: true,
    color: dark ? white : black
  }, title), /*#__PURE__*/React.createElement(Price, {
    bold: true,
    color: dark ? white : red
  }, price)), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    label: "Learn More",
    dark: dark
  }));
};

var _templateObject$p, _templateObject2$j, _templateObject3$c;
var Container$h = styled__default["default"](Box)(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  padding: 72px 96px;\n  background-image: url('/journeyline-quote-box-left.svg');\n  background-repeat: no-repeat;\n  background-position: 48px;\n  height: 800px;\n\n  @media (max-width: 768px) {\n    padding: 12px 0;\n    background-image: none;\n    display: flex;\n    flex-direction: column;\n  }\n"])));
var HeroImage = styled__default["default"](Box)(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n  height: 584px;\n  width: 1293px;\n  z-index: -1;\n\n  @media (max-width: 768px) {\n    width: 100%;\n    height: 300px;\n    z-index: 1;\n  }\n"])));
var Content = styled__default["default"](Box)(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n  @media (min-width: 769px) {\n    position: absolute;\n    padding: 20px;\n    right: 100px;\n    top: 136px;\n    height: 400px;\n    max-width: 400px;\n    background-color: white;\n    z-index: 2;\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n    padding: 12px 0;\n  }\n"])));
var QuoteBoxHero = (function (_ref) {
  var image = _ref.image,
    headline = _ref.headline,
    description = _ref.description,
    actionLabel = _ref.actionLabel,
    action = _ref.action;
  return /*#__PURE__*/React__default["default"].createElement(Container$h, null, /*#__PURE__*/React__default["default"].createElement(HeroImage, null, /*#__PURE__*/React__default["default"].createElement(Image$1, {
    src: image
  })), /*#__PURE__*/React__default["default"].createElement(Content, null, /*#__PURE__*/React__default["default"].createElement(ContentBlock, {
    headline: /*#__PURE__*/React__default["default"].createElement(H4, null, headline),
    content: /*#__PURE__*/React__default["default"].createElement(Box, {
      mb: "20px"
    }, /*#__PURE__*/React__default["default"].createElement(Body, {
      large: true,
      bold: true,
      color: grey400
    }, description)),
    action: /*#__PURE__*/React__default["default"].createElement(Button, {
      compact: true,
      color: red,
      onClick: action,
      label: actionLabel
    })
  })));
});

var QuotedImageSection = (function (_ref) {
  var variant = _ref.variant,
    content = _ref.content,
    image = _ref.image;
  return variant !== 'right' ? /*#__PURE__*/React__default["default"].createElement(TwoColumn, {
    padding: "0 48px 0 0",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(QuoteBoxImage, {
    variant: variant,
    image: image
  }), /*#__PURE__*/React__default["default"].createElement(Box, {
    w: "90%",
    pl: "10%"
  }, content)) : /*#__PURE__*/React__default["default"].createElement(TwoColumn, {
    padding: "0 0 0 48px",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Box, {
    w: "90%",
    pr: "10%"
  }, content), /*#__PURE__*/React__default["default"].createElement(QuoteBoxImage, {
    variant: variant,
    image: image
  }));
});

var SearchContext = /*#__PURE__*/React$1.createContext({
  visible: false,
  open: function open() {},
  close: function close() {},
  onSearch: function onSearch() {},
  labels: {
    action: 'Search',
    placeholder: 'Enter search term',
    instructions: 'Enter your search term below'
  }
});
var SearchContext$1 = (function (_ref) {
  var onSearch = _ref.onSearch,
    labels = _ref.labels,
    children = _ref.children;
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var open = function open() {
    return setVisible(true);
  };
  var close = function close() {
    return setVisible(false);
  };
  return /*#__PURE__*/React__default["default"].createElement(SearchContext.Provider, {
    value: {
      onSearch: onSearch,
      visible: visible,
      open: open,
      close: close,
      labels: labels
    }
  }, children);
});

var SharingSidebarSection = (function (_ref) {
  var onShare = _ref.onShare,
    title = _ref.title;
  return /*#__PURE__*/React__default["default"].createElement(DetailSidebarSection, {
    title: title
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "space-between",
    maxWidth: "160px"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "pinterest",
    color: red,
    onClick: onShare('pinterest')
  }), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "facebook",
    color: red,
    onClick: onShare('facebook')
  }), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "twitter",
    color: red,
    onClick: onShare('twitter')
  }), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "instagram",
    color: red,
    onClick: onShare('instagram')
  })));
});

var _templateObject$o, _templateObject2$i;
var Container$g = styled__default["default"](Box)(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n  width: 100%;\n  @media (min-width: 1025px) {\n    height: 760px;\n  }\n  @media (max-width: 1024px) {\n    height: 540px;\n  }\n  @media (max-width: 768px) {\n    height: 268px;\n    max-height: 440px;\n  }\n  position: relative;\n"])));
var Controls = styled__default["default"](Box)(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  z-index: 99;\n"])));
var SimpleCarousel = (function (_ref) {
  var children = _ref.children,
    onIndexChange = _ref.onIndexChange;
  var _useState = React$1.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var next = function next() {
    var nextIndex = index + 1;
    setIndex(nextIndex);
    if (onIndexChange) {
      onIndexChange(nextIndex);
    }
  };
  var prev = function prev() {
    var nextIndex = index - 1;
    setIndex(nextIndex);
    if (onIndexChange) {
      onIndexChange(nextIndex);
    }
  };
  var arrayChildren = React__default["default"].Children.toArray(children);
  var child = /*#__PURE__*/React__default["default"].cloneElement(arrayChildren[index], _objectSpread2({}, arrayChildren[index].props));
  return /*#__PURE__*/React__default["default"].createElement(Container$g, null, child, arrayChildren.length > 1 && /*#__PURE__*/React__default["default"].createElement(Controls, null, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "left",
    disabled: index <= 0,
    color: grey400,
    onClick: prev,
    width: 30
  }), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "right",
    disabled: index >= children.length - 1,
    color: grey400,
    onClick: next,
    width: 30
  })));
});

var _templateObject$n;
var Container$f = styled__default["default"](FlexBox)(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  padding: 48px;\n  visibility: ", ";\n  background-color: ", "F5;\n  z-index: 999;\n"])), function (props) {
  return props.visible ? 'visible' : 'hidden';
}, purple);
var SiteSearch = (function () {
  var _useState = React$1.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    term = _useState2[0],
    setTerm = _useState2[1];
  var _useContext = React$1.useContext(SearchContext);
    _useContext.open;
    var close = _useContext.close,
    labels = _useContext.labels,
    onSearch = _useContext.onSearch,
    visible = _useContext.visible;
  var actionLabel = labels.action,
    placeholder = labels.placeholder,
    instructions = labels.instructions;
  var handleChange = function handleChange(e) {
    setTerm(e.currentTarget.value);
  };
  var handleSearch = function handleSearch() {
    onSearch(term);
    close();
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$f, {
    visible: visible
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "close",
    dark: true,
    onClick: close
  })), /*#__PURE__*/React__default["default"].createElement(H4, {
    dark: true
  }, instructions), /*#__PURE__*/React__default["default"].createElement(ButtonInput, {
    dark: true,
    label: actionLabel,
    placeholder: placeholder,
    onClick: handleSearch,
    onChange: handleChange
  }));
});

var _templateObject$m, _templateObject2$h;
styled__default["default"](FlexBox)(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var SearchTitle = styled__default["default"](Body)(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n    font-weight: bold;\n    margin-bottom: 15px;\n"])));
var SiteSearchResult = (function (_ref) {
  var body = _ref.body,
    title = _ref.title,
    type = _ref.type,
    action = _ref.action,
    _ref$actionLabel = _ref.actionLabel,
    actionLabel = _ref$actionLabel === void 0 ? "Read more" : _ref$actionLabel;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    minHeight: "120px",
    mt: "10px",
    mb: "10px",
    flexDirection: breakpoint === 'mobile' ? "column" : 'row'
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    w: breakpoint === 'mobile' ? '100%' : '10%'
  }, /*#__PURE__*/React__default["default"].createElement(H6, {
    uppercase: true,
    variant: "condensed"
    // margin='0 40px 0 0'
  }, type)), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    w: breakpoint === 'mobile' ? '100%' : '75%',
    mb: breakpoint === 'mobile' ? '30px' : '0'
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(SearchTitle, null, title), /*#__PURE__*/React__default["default"].createElement(Body, null, "".concat(body.substring(0, 250), "...")))), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: breakpoint === 'mobile' ? 'flex-start' : 'flex-end',
    w: breakpoint === 'mobile' ? '100%' : '15%'
  }, /*#__PURE__*/React__default["default"].createElement(Box, null, /*#__PURE__*/React__default["default"].createElement(Button, {
    color: red,
    onClick: action,
    label: actionLabel,
    margin: "0",
    compact: true
  }))));
});

var _templateObject$l, _templateObject2$g;
var CardContainer$2 = styled__default["default"](Box)(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n    flex: ", ";\n    max-width: ", ";\n    padding: 10px;\n"])), function (props) {
  return props.mobile ? '1 0 100%' : "1 0 ".concat(100 / props.cardsPerRow, "%");
}, function (props) {
  return props.mobile ? '100%' : "".concat(100 / props.cardsPerRow, "%");
});
var Container$e = styled__default["default"](FlexBox)(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n  width: 100%;  \n  flex-direction: row;\n  flex-wrap: wrap;\n"])));
var SearchResultsGrid = (function (_ref) {
  var _ref$cardsPerRow = _ref.cardsPerRow,
    cardsPerRow = _ref$cardsPerRow === void 0 ? 3 : _ref$cardsPerRow,
    children = _ref.children;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  return /*#__PURE__*/React__default["default"].createElement(Container$e, null, React__default["default"].Children.map(children, function (c, index) {
    return /*#__PURE__*/React__default["default"].createElement(CardContainer$2, {
      mobile: breakpoint === 'mobile',
      cardsPerRow: cardsPerRow,
      key: "card-".concat(index)
    }, /*#__PURE__*/React__default["default"].cloneElement(c, c.props));
  }));
});

var _templateObject$k, _templateObject2$f;
var SocialRow = styled__default["default"](Box)(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  justify-content: flex-start;\n"])));
var SocialIcon = styled__default["default"](Icon)(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
var SocialButtons = (function (_ref) {
  var dark = _ref.dark,
    color = _ref.color;
  var visitSocialPage = function visitSocialPage(url) {
    return function () {
      return window.open(url);
    };
  };
  return /*#__PURE__*/React__default["default"].createElement(SocialRow, null, /*#__PURE__*/React__default["default"].createElement(Box, {
    h: "40px",
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(SocialIcon, {
    icon: "facebook",
    color: dark ? white : color,
    onClick: visitSocialPage('https://www.facebook.com/DallasMuseumofArt/')
  })), /*#__PURE__*/React__default["default"].createElement(Box, {
    h: "40px",
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(SocialIcon, {
    icon: "instagram",
    color: dark ? white : color,
    onClick: visitSocialPage('https://www.instagram.com/dallasmuseumart/')
  })), /*#__PURE__*/React__default["default"].createElement(Box, {
    h: "40px",
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(SocialIcon, {
    icon: "x",
    color: dark ? white : color,
    onClick: visitSocialPage('https://x.com/DallasMuseumArt')
  })), /*#__PURE__*/React__default["default"].createElement(Box, {
    h: "40px",
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(SocialIcon, {
    icon: "linkedin",
    color: dark ? white : color,
    onClick: visitSocialPage('https://www.linkedin.com/company/dallas-museum-of-art/')
  })), /*#__PURE__*/React__default["default"].createElement(Box, {
    h: "40px",
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(SocialIcon, {
    icon: "youtube",
    color: dark ? white : color,
    onClick: visitSocialPage('https://www.youtube.com/user/dallasmuseumofart')
  })));
});

var SocialShare = (function (_ref) {
  var _ref$url = _ref.url,
    url = _ref$url === void 0 ? window.location : _ref$url,
    title = _ref.title,
    _ref$dark = _ref.dark,
    dark = _ref$dark === void 0 ? false : _ref$dark,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? red : _ref$color,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? 'https://beta.dma.org/logo.svg' : _ref$media;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, null, /*#__PURE__*/React__default["default"].createElement(reactShare.FacebookShareButton, {
    url: url,
    quote: title
  }, /*#__PURE__*/React__default["default"].createElement(Box, {
    h: "40px",
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    icon: "facebook",
    color: dark ? white : color
  }))), /*#__PURE__*/React__default["default"].createElement(reactShare.PinterestShareButton, {
    description: title,
    media: media,
    url: url
  }, /*#__PURE__*/React__default["default"].createElement(Box, {
    h: "40px",
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    icon: "pinterest",
    color: dark ? white : color
  }))), /*#__PURE__*/React__default["default"].createElement(reactShare.TwitterShareButton, {
    titlr: title,
    url: url
  }, /*#__PURE__*/React__default["default"].createElement(Box, {
    h: "40px",
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    icon: "twitter",
    color: dark ? white : color
  }))));
});

var _templateObject$j, _templateObject2$e, _templateObject3$b;
var List = styled__default["default"](FlexBox)(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  gap: 10px;\n  width: 100%;\n  overflow-x: ", ";\n  @media (max-width: 768px) {\n    overflow-x: scroll;\n  }\n"])), function (props) {
  return props.mode === 'gesture' ? 'scroll' : 'hidden';
});
styled__default["default"](FlexBox)(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n  background-color: red;\n  width: 200px;\n  heght: 50px;\n"])));
var Container$d = styled__default["default"](FlexBox)(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n  flex-direction: column;\n  ", "\n  ", ";\n  padding: 0 48px;\n"])), function (props) {
  return props.color ? "background-color: ".concat(props.color, ";") : '';
}, function (props) {
  return props.closed ? 'display: none;' : '';
});
var Slideshow = (function (_ref) {
  var children = _ref.children,
    label = _ref.label,
    variant = _ref.variant,
    mode = _ref.mode,
    color = _ref.color;
    _ref.dark;
    _ref.onClick;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    closed = _useState2[0],
    setClosed = _useState2[1];
  var _useState3 = React$1.useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];
  var _useState5 = React$1.useState([]),
    _useState6 = _slicedToArray(_useState5, 2);
    _useState6[0];
    _useState6[1];
  var _useState7 = React$1.useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    pageSize = _useState8[0],
    setPageSize = _useState8[1];
  var _useState9 = React$1.useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    pageCount = _useState10[0],
    setPageCount = _useState10[1];
  var _useState11 = React$1.useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    childWidth = _useState12[0],
    setChildWidth = _useState12[1];
  var listRef = React$1.useRef();
  var toggle = function toggle() {
    return setClosed(!closed);
  };
  React$1.useEffect(function () {
    if (listRef.current) {
      var listWidth = listRef.current.clientWidth;
      var _children = listRef.current.children;
      var _childWidth = _children[1] ? _children[1].offsetLeft - _children[0].offsetLeft : _children[0].width;
      var nextPageSize = Math.floor(listWidth / _childWidth);
      var nextPageCount = Math.ceil(_children.length / nextPageSize);
      setChildWidth(_childWidth);
      setPageSize(nextPageSize);
      setPageCount(nextPageCount);
    }
  }, [listRef]);
  var next = function next() {
    var nextPage = currentPage + 1;
    listRef.current.scroll({
      left: childWidth * pageSize * nextPage,
      behavior: 'smooth'
    });
    setCurrentPage(nextPage);
  };
  var prev = function prev() {
    var nextPage = currentPage - 1;
    listRef.current.scroll({
      left: childWidth * pageSize * nextPage,
      behavior: 'smooth'
    });
    setCurrentPage(nextPage);
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$d, {
    column: true,
    closed: closed,
    color: color
  }, variant === "collapsible" && /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    alignSelf: "flex-end",
    margin: "20px 0"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "close",
    color: grey400,
    onClick: toggle,
    width: 30
  })), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "space-between",
    alignItems: "center",
    w: "100%"
  }, /*#__PURE__*/React__default["default"].createElement(H5, {
    margin: "20px 0"
  }, label), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column"
  }, breakpoint !== 'mobile' && mode !== 'gesture' && /*#__PURE__*/React__default["default"].createElement(FlexBox, null, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "left",
    disabled: currentPage <= 0,
    color: grey400,
    onClick: prev,
    width: 30
  }), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "right",
    disabled: currentPage >= pageCount - 1,
    color: grey400,
    onClick: next,
    width: 30
  })))), /*#__PURE__*/React__default["default"].createElement(List, {
    justifyContent: "flex-start",
    "align-items": "center",
    ref: listRef,
    mode: mode
  }, children.map(function (child, i) {
    return /*#__PURE__*/React__default["default"].cloneElement(child, _objectSpread2(_objectSpread2({}, child.props), {}, {
      key: "slide-child-".concat(i)
    }));
  })));
});

var _templateObject$i, _templateObject2$d, _templateObject3$a;
var Container$c = styled__default["default"](Box)(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: visible;\n\n  @media (max-width: 768px) {\n    overflow-y: visible;\n    overflow-x: hidden;\n  }\n"])));
var VideoHeroContainer = styled__default["default"](Box)(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n  @media (min-width: 1025px) {\n    height: 600px;\n  }\n  @media (max-width: 1024px) {\n    height: 500px;\n  }\n  @media (max-width: 768px) {\n    height: 300px;\n  }\n  width: 100%;\n  z-index: 1;\n  overflow: hidden;\n  background-color: ", ";\n"])), grey700);
var VideoComponent = styled__default["default"].video(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n  @media (min-width: 1025px) {\n    height: 590px;\n  }\n  @media (max-width: 1024px) {\n    height: 490px;\n  }\n  @media (max-width: 768px) {\n    height: 290px;\n  }\n// min-width: 100%;\n  // min-height: 100%;\n  // max-width: 1000px;\n  width: auto;\n  height: auto;\n  position: absolute;\n  // top: 50%;\n  // transform: translate(-50%, -50%);\n  left: 50%;\n  transform: translate(-50%, 0);\n"])));
var VideoHero = (function (_ref) {
  var desktop = _ref.desktop,
    tablet = _ref.tablet,
    mobile = _ref.mobile,
    autoPlay = _ref.autoPlay,
    muted = _ref.muted,
    loop = _ref.loop;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var getVideoSource = function getVideoSource() {
    switch (breakpoint) {
      case "mobile":
        return mobile;
      case "tablet":
      case "tabletSmall":
        return tablet;
      default:
        return desktop;
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$c, null, /*#__PURE__*/React__default["default"].createElement(VideoHeroContainer, {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React__default["default"].createElement(VideoComponent, {
    src: getVideoSource(),
    muted: muted || true,
    loop: loop || true,
    autoPlay: autoPlay || true,
    playsInline: true,
    controls: true
  })));
});

var _templateObject$h;
var VideoPlayerComponent = styled__default["default"].video(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: auto;\n  max-width: 100%;\n  display: block;\n  object-fit: cover;\n  overflow: hidden;\n\n  /* Maintain aspect ratio */\n  aspect-ratio: 16 / 9;\n\n  /* Responsive breakpoints */\n  @media (max-width: 768px) {\n    aspect-ratio: 16 / 9;\n    width: 100%;\n    height: auto;\n  }\n\n  @media (max-width: 480px) {\n    aspect-ratio: 16 / 9;\n    width: 100%;\n    height: auto;\n  }\n\n  /* Ensure video controls are responsive */\n  &::-webkit-media-controls {\n    width: 100%;\n  }\n\n  &::-webkit-media-controls-panel {\n    width: 100%;\n  }\n"])));
var VideoPlayer = (function (_ref) {
  var desktop = _ref.desktop,
    tablet = _ref.tablet,
    mobile = _ref.mobile,
    autoPlay = _ref.autoPlay,
    muted = _ref.muted,
    loop = _ref.loop;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var getVideoSource = function getVideoSource() {
    switch (breakpoint) {
      case "mobile":
        return mobile;
      case "tablet":
      case "tabletSmall":
        return tablet;
      default:
        return desktop;
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(VideoPlayerComponent, {
    src: getVideoSource(),
    muted: muted || true,
    loop: loop || true,
    autoPlay: autoPlay || true,
    playsInline: true,
    controls: true,
    preload: "metadata"
  });
});

var _templateObject$g, _templateObject2$c, _templateObject3$9, _templateObject4$6;
var Container$b = styled__default["default"](Box)(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  margin-bottom: 120px;\n  @media (max-width: 768px) {\n    flex-direction: column-reverse;\n    margin-bottom: 12px;\n  }\n"])));
var Sixty$1 = styled__default["default"](Box)(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n  width: 60%;\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n"])));
var Forty$1 = styled__default["default"](Box)(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n  width: 40%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n\n  @media (min-width: 1025px) {\n    padding: 100px 48px 0 48px; \n  }\n\n  @media (max-width: 1024px) {\n    padding: 60px 24px 0 24px; \n  }\n\n  @media (max-width: 768px) {\n    padding: 24px 12px 0 12px; \n    width: 100%;\n  }\n"])));
styled__default["default"](H5)(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n  margin: 5px;\n"])));
var CollectionCarousel = (function (_ref) {
  var contents = _ref.contents,
    images = _ref.images,
    headline = _ref.headline,
    actions = _ref.actions,
    actionLabel = _ref.actionLabel;
  var _useState = React$1.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var handleIndexChange = function handleIndexChange(i) {
    return setIndex(i);
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$b, null, /*#__PURE__*/React__default["default"].createElement(Forty$1, null, /*#__PURE__*/React__default["default"].createElement(ContentBlock, {
    headline: headline,
    content: contents[index],
    action: /*#__PURE__*/React__default["default"].createElement(Button, {
      variant: "tertiary",
      label: actionLabel,
      onClick: actions[index]
    })
  })), /*#__PURE__*/React__default["default"].createElement(Sixty$1, null, /*#__PURE__*/React__default["default"].createElement(SimpleCarousel, {
    onIndexChange: handleIndexChange
  }, images)));
});

var _templateObject$f;
var JourneyLine = styled__default["default"](Box)(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n    background-image: url(/journeyline-secondary-down.svg);\n    width: 186px;\n    height: 69px;\n"])));
var CollectionFooter = (function (_ref) {
  var title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    padding: "0"
  }, /*#__PURE__*/React__default["default"].createElement(JourneyLine, null), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    backgroundColor: grey600,
    flexDirection: "column",
    padding: "35px",
    w: "95%"
  }, /*#__PURE__*/React__default["default"].createElement(H5, {
    margin: "10px 0"
  }, title), /*#__PURE__*/React__default["default"].createElement(Body, null, description))));
});

var _templateObject$e, _templateObject2$b;
var Container$a = styled__default["default"](Box)(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  background-repeat: no-repeat;\n  width: 100%;\n\n  @media (min-width: 1025px) {\n    height: 1200px;\n    background-image: url(/journeyline-collections.svg);\n  }\n\n  @media (max-width: 1024px) {\n    height: 940px;\n    background-image: url(/journeyline-collections-tablet.svg);\n    background-position: 10px 0;\n  }\n\n  @media (max-width: 768px) {\n    height: fit-content;\n    background-image: url(/journeyline-collections-tablet-p.svg);\n    background-image: none;\n  }\n"])));
var Right$3 = styled__default["default"](Box)(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n  align-self: flex-end;\n\n  @media (max-width: 768px) {\n    margin-bottom: 24px;\n  }\n\n  @media (min-width: 769px) {\n    margin-bottom: 48px;\n    margin-right: 12px;\n  }\n"])));
var CollectionsSection = (function (_ref) {
  var actions = _ref.actions,
    actionLabel = _ref.actionLabel,
    contents = _ref.contents,
    images = _ref.images,
    header = _ref.header;
  return /*#__PURE__*/React__default["default"].createElement(Container$a, null, /*#__PURE__*/React__default["default"].createElement(Right$3, null, header), /*#__PURE__*/React__default["default"].createElement(CollectionCarousel, {
    contents: contents,
    actions: actions,
    images: images,
    actionLabel: actionLabel
  }));
});

var _templateObject$d;
var ObjectDetail = function ObjectDetail(_ref) {
  var detail = _ref.detail;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "row",
    alignContent: "space-between",
    margin: "0 0 15px 0"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    w: "115px",
    justifyContent: "flex-end",
    margin: "0 10px 0 0"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    bold: true,
    textAlign: "right"
  }, detail.label, ":")), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    w: "275px"
  }, detail.data));
};
var ObjectDetailsContainer = styled__default["default"](FlexBox)(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral([" //TODO Add new props into base Flexbox\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: space-between;\n  margin-right: 10px;\n  gap: 10px;\n"])));
var CollectionItemDescription = (function (_ref2) {
  var content = _ref2.content;
  var objectDetails = content.objectDetails,
    body = content.body;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    w: "70%",
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "large",
    bold: true,
    style: {
      marginBottom: '40px'
    }
  }, "Object Details"), /*#__PURE__*/React__default["default"].createElement(ObjectDetailsContainer, null, objectDetails.map(function (detail, index) {
    return /*#__PURE__*/React__default["default"].createElement(ObjectDetail, {
      key: index,
      detail: detail
    });
  })), /*#__PURE__*/React__default["default"].createElement(Divider$1, null), /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "large"
  }, body)));
});

var _templateObject$c;
var ItemName = styled__default["default"](FlexBox)(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral([" \n  font-family: usual, sans-serif;\n  font-weight: bold;\n  padding: 0;\n  line-height: 1;\n\n  @media (min-width: 1025px) {\n    margin: 0;\n    font-size: 38px;\n  }\n  @media (max-width: 1024px) {\n    margin: 0;\n    font-size: 34px;\n  }\n  @media (max-width: 768px) {\n    font-size: 28px;\n    margin: auto;\n  }\n"])));
var CollectionItemHeader = (function (_ref) {
  var title = _ref.title,
    children = _ref.children;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Divider$1, {
    margin: breakpoint === 'mobile' ? '0 0 20px 0' : '20px 0'
  }), /*#__PURE__*/React__default["default"].createElement(TwoColumn, {
    variant: "wide-left",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(ItemName, {
    dangerouslySetInnerHTML: {
      __html: marked__default["default"].parse(title)
    }
  }), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    style: {
      gap: '20px'
    },
    alignItems: "right"
  }, children)), /*#__PURE__*/React__default["default"].createElement(Divider$1, {
    margin: "20px 0"
  }));
});

var _templateObject$b, _templateObject2$a, _templateObject3$8, _templateObject4$5;
var Container$9 = styled__default["default"](Box)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-repeat: no-repeat;\n\n  @media (min-width: 1025px) {\n    padding-top: 120px;\n    padding-bottom: 100px;\n    background-image: url(/journeyline-events.svg);\n  }\n\n  @media (max-width: 1024px) {\n    padding-top: 80px;\n    padding-bottom: 60px;\n    background-image: url(/journeyline-events-tablet.svg);\n  }\n\n  @media (max-width: 768px) {\n    padding-top: 40px;\n    padding-bottom: 20px;\n    background-position: -80px -80px;\n    background-image: none;\n  }\n"])));
var CardRow$1 = styled__default["default"](Box)(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  @media(min-width: 1025px){\n    padding: 0 48px;\n  }\n\n  @media(max-width: 1024px){\n    padding: 0 24px;\n  }\n\n  @media(max-width: 768px){\n    flex-direction: column;\n    padding: 0 12px;\n  }\n"])));
var Right$2 = styled__default["default"](Box)(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n  align-self: flex-end;\n  margin-bottom: 50px;\n  margin-right: 48px;\n  @media (max-width: 1024px) {\n    margin-right: 24px;\n  }\n"])));
var CardContainer$1 = styled__default["default"](Box)(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n  width: calc((100% - 48px)/3);\n  @media (max-width: 768px) {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n"])));
var EventsSection = (function (_ref) {
  var header = _ref.header,
    children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(Container$9, null, /*#__PURE__*/React__default["default"].createElement(Right$2, null, header), /*#__PURE__*/React__default["default"].createElement(CardRow$1, null, React__default["default"].Children.map(children, function (c) {
    return /*#__PURE__*/React__default["default"].createElement(CardContainer$1, null, /*#__PURE__*/React__default["default"].cloneElement(c, c.props));
  })));
});

var _templateObject$a, _templateObject2$9, _templateObject3$7, _templateObject4$4, _templateObject5$2;
var Background = styled__default["default"](Box)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  width 100%;\n  height: 100%;\n\n  @media (min-width: 1025px) {\n    top: -30px;\n    background-image: url(/journeyline-exhibitions.svg);\n  }\n\n  @media (max-width: 1024px) {\n    background-image: url(/journeyline-exhibitions-tablet.svg);\n  }\n\n  @media (max-width: 768px) {\n    top: 0;\n    background-image: url(/journeyline-exhibitions-mobile.svg);\n    background-position: 150px 0;\n  }\n\n  background-repeat: no-repeat;\n  position: absolute;\n  z-index: -1;\n"])));
var Container$8 = styled__default["default"](Box)(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  @media (min-width: 1025px) {\n    height: 1200px;\n  }\n  @media (max-width: 1024px) {\n    height: 900px;\n  }\n  @media (max-width: 768px) {\n    height: fit-content;\n    height: 1215px;\n    max-height: 1215px;\n  }\n  overflow: visible;\n"])));
var Right$1 = styled__default["default"](Box)(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n  align-self: flex-end;\n  @media (min-width: 1025px) {\n    margin-top: 80px;\n  }\n  @media (max-width: 1024px) {\n    margin-top: 70px;\n  }\n  @media (max-width: 768px) {\n    margin-top: 24px;\n  }\n  margin-bottom: 20px;\n  margin-right: 24px;\n"])));
var ContentArea = styled__default["default"](Box)(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  flex-wrap: wrap;\n  max-height: 880px;\n\n  @media (min-width: 1025px) {\n    margin-left: 120px;\n    margin-top: -30px;\n    width: 1118px;\n  }\n  @media (max-width: 1024px) {\n    margin-left: 80px;\n    margin-top: -15px;\n    width: 810px;\n  }\n  @media (max-width: 768px) {\n    justify-content: flex-start;\n    flex-wrap: nowrap;\n    width: 100%;\n    padding: 0 12px;\n    margin-left: 0;\n    margin-top: 0;\n  }\n"])));
var ContentContainer = styled__default["default"](Box)(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n  @media (min-width: 1025px) {\n    width: 540px;\n    height: 380px;\n    margin-bottom: 60px;\n    margin-left: 40px;\n  }\n  @media (max-width: 1024px) {\n    width: 390px;\n    height: 275px;\n    margin-bottom: 30px;\n    margin-left: 30px;\n  }\n  @media (max-width: 768px) {\n    margin-left: 0;\n    margin-right: 12px;\n    width: 100%;\n    height: 270px;\n    min-height: 270px;\n    margin-bottom: 24px;\n  }\n"])));
var ExhibitionsSection = (function (_ref) {
  var header = _ref.header,
    children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(Container$8, null, /*#__PURE__*/React__default["default"].createElement(Background, null), /*#__PURE__*/React__default["default"].createElement(Right$1, null, header), /*#__PURE__*/React__default["default"].createElement(ContentArea, null, React__default["default"].Children.map(children, function (c) {
    return /*#__PURE__*/React__default["default"].createElement(ContentContainer, null, /*#__PURE__*/React__default["default"].cloneElement(c, c.props));
  })));
});

var _templateObject$9, _templateObject2$8, _templateObject3$6, _templateObject4$3, _templateObject5$1, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
var Container$7 = styled__default["default"](Box)(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  justify-content: right;\n  width: 100%;\n  box-sizing: border-box;\n"])));
var FooterContainer = styled__default["default"](Box)(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-sizing: border-box;\n  height: fit-content;\n  width: 100%;\n  padding: 30px 50px;\n  overflow: visible;\n\n  @media (max-width: 768px) {\n    padding: 0;\n  }\n"])), grey800);
var HeaderTop = styled__default["default"](Box)(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #E5E6E7;\n  padding: 24px 0;\n  @media (max-width: 768px) {\n    padding: 24px;\n  }\n"])));
var HeaderBottom = styled__default["default"](Box)(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-top: 1px solid #E5E6E7;\n  padding: 30px 50px 10px 50px;\n"])));
var HeaderContent = styled__default["default"](Box)(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-start;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n"])));
var HeaderColumn = styled__default["default"](Box)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  @media (min-width: 1025px) {\n    padding: 48px 24px;\n    border-right: 1px solid #E5E6E7;\n    &:last-child {\n      border-right: none;\n    }\n\n    &:first-child {\n      padding-left: 0;\n    }\n  }\n\n  @media (max-width: 1024px) {\n    padding: 24px;\n    border-right: 1px solid #E5E6E7;\n\n    &:last-child {\n      border-right: none;\n    }\n\n    &:first-child {\n      padding-left: 0;\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 24px;\n    width: 100%;\n    border-bottom: 1px solid #E5E6E7;\n    &:first-child {\n      padding-left: 24px;\n    }\n  }\n"])));
var Legal = styled__default["default"](Caption)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 730px;\n  margin-top: 10px;\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n"])));
var Journeyline = styled__default["default"](Box)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: relative;\n  background-image: url(/journeyline-footer.svg);\n  background-repeat: no-repeat;\n  width: 40%;\n  height: 100px;\n  margin-left: 60%;\n"])));
var RightLinks = styled__default["default"](Box)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n\n  > * {\n    width: 50%;\n  }\n"])));
var LinkH6 = styled__default["default"](H6)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  cursor: pointer;\n"])));
var LinkBody = styled__default["default"](Body)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  text-decoration: none;\n  cursor: pointer;\n"])));
var Footer = function Footer(_ref) {
  var labels = _ref.labels,
    content = _ref.content,
    actions = _ref.actions,
    navigation = _ref.navigation;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var scrollUp = function scrollUp() {
    return window.scroll(0, 0);
  };
  var handleLink = function handleLink(slug) {
    return function () {
      return actions.navigate(slug);
    };
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$7, null, /*#__PURE__*/React__default["default"].createElement(Journeyline, null), /*#__PURE__*/React__default["default"].createElement(FooterContainer, null, /*#__PURE__*/React__default["default"].createElement(HeaderTop, null, /*#__PURE__*/React__default["default"].createElement(Logo, {
    variant: "footer",
    width: "140px",
    height: "95px"
  }), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "text",
    color: red,
    onClick: scrollUp,
    label: labels.scroll
  })), /*#__PURE__*/React__default["default"].createElement(HeaderContent, null, /*#__PURE__*/React__default["default"].createElement(HeaderColumn, {
    w: breakpoint === 'tablet' ? '20%' : '30%'
  }, /*#__PURE__*/React__default["default"].createElement(H6, {
    uppercase: true,
    variant: "condensed",
    color: grey400
  }, "Dallas Museum Of Art"), /*#__PURE__*/React__default["default"].createElement(Caption, null, "1717 North Harwood"), /*#__PURE__*/React__default["default"].createElement(Caption, null, "Dallas, Texas 75201")), /*#__PURE__*/React__default["default"].createElement(HeaderColumn, {
    w: "30%"
  }, navigation.left.map(function (link, index) {
    return /*#__PURE__*/React__default["default"].createElement(LinkH6, {
      uppercase: true,
      variant: "condensed",
      color: grey400,
      onClick: handleLink(link.slug),
      key: index
    }, link.label);
  })), /*#__PURE__*/React__default["default"].createElement(HeaderColumn, {
    w: "30%"
  }, /*#__PURE__*/React__default["default"].createElement(LinkH6, {
    uppercase: true,
    variant: "condensed",
    color: grey400,
    onClick: handleLink('/newsletters')
  }, labels.newsletter), /*#__PURE__*/React__default["default"].createElement(RightLinks, null, navigation.right.map(function (link, index) {
    return /*#__PURE__*/React__default["default"].createElement(LinkBody, {
      variant: "small",
      onClick: handleLink(link.slug),
      key: index
    }, link.label);
  }))), /*#__PURE__*/React__default["default"].createElement(HeaderColumn, {
    w: "30%"
  }, /*#__PURE__*/React__default["default"].createElement(H6, {
    uppercase: true,
    variant: "condensed",
    color: grey400
  }, labels.social), /*#__PURE__*/React__default["default"].createElement(SocialButtons, null))), /*#__PURE__*/React__default["default"].createElement(HeaderBottom, null, /*#__PURE__*/React__default["default"].createElement(Legal, {
    dangerouslySetInnerHTML: {
      __html: marked.marked.parse(content)
    }
  }))));
};

var _templateObject$8, _templateObject2$7, _templateObject3$5;
var Container$6 = styled__default["default"](Box)(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  margin-bottom: 120px;\n\n  @media (max-width: 768px) {\n    flex-direction: column-reverse;\n  }\n"])));
var Sixty = styled__default["default"](Box)(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n  width: 60%;\n\n  @media (max-width: 1024px) {\n    height: 540px;\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n    height: 300px;\n  }\n"])));
var Forty = styled__default["default"](Box)(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n  width: 40%;\n  background-image: url(/journeyline-secondary-left.svg);\n  background-repeat: no-repeat;\n  background-position: -300px 100px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n\n  @media (min-width: 1025px) {\n    padding: 260px 48px 0 48px; \n  }\n\n  @media (max-width: 1024px) {\n    height: 540px;\n    padding: 200px 24px 0 24px; \n    background-position: -400px 20px;\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n    height: fit-content;\n    padding: 20px 24px 0 24px; \n    background-image: none;\n  }\n"])));
var HeroCarousel = (function (_ref) {
  var children = _ref.children,
    lightHeadline = _ref.lightHeadline,
    boldHeadline = _ref.boldHeadline,
    content = _ref.content,
    action = _ref.action,
    actionLabel = _ref.actionLabel,
    variant = _ref.variant;
  return /*#__PURE__*/React__default["default"].createElement(Container$6, null, /*#__PURE__*/React__default["default"].createElement(Forty, null, /*#__PURE__*/React__default["default"].createElement(ContentBlock, {
    headline: /*#__PURE__*/React__default["default"].createElement(HeroHeader, {
      lightText: lightHeadline,
      boldText: boldHeadline,
      variant: variant
    }),
    content: /*#__PURE__*/React__default["default"].createElement(Body, {
      variant: "large",
      bold: true,
      color: grey400
    }, content),
    action: action ? /*#__PURE__*/React__default["default"].createElement(Button, {
      variant: "tertiary",
      label: actionLabel,
      onClick: action
    }) : undefined
  })), /*#__PURE__*/React__default["default"].createElement(Sixty, null, /*#__PURE__*/React__default["default"].createElement(SimpleCarousel, null, children)));
});

var _templateObject$7, _templateObject2$6, _templateObject3$4, _templateObject4$2;
var journeylines = {
  desktop: ['secondary-right', 'primary-up', 'quote-box'],
  tablet: ['secondary-right', 'primary-up', 'quote-box'],
  tabletSmall: ['secondary-right', 'primary-up', 'quote-box'],
  mobile: ['top', 'middle', 'bottom']
};
var Row = styled__default["default"](Box)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  margin-bottom: 70px;\n  overflow: visible;\n  :last-child {\n    margin-bottom: 120px;\n  }\n"])));
var Container$5 = styled__default["default"](Box)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n  width: 100%;\n  adlkfjn  padding-bottom: 50px;\n  margin-bottom: 50px;\n  margin-top: 50px;\n"], ["\n  width: 100%;\n  adlkfjn\\\n  padding-bottom: 50px;\n  margin-bottom: 50px;\n  margin-top: 50px;\n"])));
var JourneylineArea = styled__default["default"](JourneylineSection)(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n  width: 100vw;\n  padding: 20px 0;\n  margin-bottom: 70px;\n"])));
var HeroContainer = styled__default["default"](Box)(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n  width: 100%;\n\n  @media (min-width: 601px) {\n    ", "\n    ", "\n  }\n\n  @media (min-width: 1025px) {\n    ", "\n    ", "\n  }\n"])), function (props) {
  return props.right ? 'padding-left: 5%; padding-right: 2%' : '';
}, function (props) {
  return props.right ? '' : 'padding-right: 5%; padding-left: 2%';
}, function (props) {
  return props.right ? 'padding-left: 15%; padding-right: 48px' : '';
}, function (props) {
  return props.right ? '' : 'padding-right: 15%; padding-left: 48px';
});
var HeroStack = function HeroStack(_ref) {
  var children = _ref.children;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  var getJourneylineByIndex = function getJourneylineByIndex(index, list) {
    var out;
    if (index === list.length - 1 && index % 2 === 0) {
      out = journeylines[breakpoint][2];
    } else {
      out = journeylines[breakpoint][index % 2];
    }
    return out;
  };
  return /*#__PURE__*/React__default["default"].createElement(Container$5, null, React__default["default"].Children.map(children, function (child, i) {
    return /*#__PURE__*/React__default["default"].createElement(Row, null, /*#__PURE__*/React__default["default"].createElement(JourneylineArea, {
      key: "Hero-".concat(i),
      variant: getJourneylineByIndex(i, children)
    }, /*#__PURE__*/React__default["default"].createElement(HeroContainer, {
      right: i % 2 === 1 ? true : undefined
    }, /*#__PURE__*/React__default["default"].cloneElement(child, _objectSpread2(_objectSpread2({}, child.props), {}, {
      right: i % 2 === 1 ? true : undefined
    })))));
  }));
};

var _templateObject$6, _templateObject2$5, _templateObject3$3, _templateObject4$1;
var Container$4 = styled__default["default"](Box)(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  padding: 64px 48px 96px 48px;\n  display: flex;\n  background-color: ", ";\n  flex-direction: column;\n"])), red);
var ItemRow = styled__default["default"](Box)(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var HeaderRow = styled__default["default"](Box)(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var ItemBox = styled__default["default"](Box)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  width: 23%;\n"])));
var ShopSection = (function (_ref) {
  var headline = _ref.headline,
    description = _ref.description,
    action = _ref.action,
    actionLabel = _ref.actionLabel,
    children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement(Container$4, null, /*#__PURE__*/React__default["default"].createElement(HeaderRow, null, /*#__PURE__*/React__default["default"].createElement(Box, {
    w: "25%",
    mr: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(H4, {
    dark: true
  }, headline)), /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    dark: true
  }, description), /*#__PURE__*/React__default["default"].createElement(Box, {
    w: "10%",
    ml: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "outlined",
    label: actionLabel,
    dark: true,
    compact: true,
    onClick: action
  }))), /*#__PURE__*/React__default["default"].createElement(ItemRow, null, React__default["default"].Children.map(children, function (c) {
    return /*#__PURE__*/React__default["default"].createElement(ItemBox, null, /*#__PURE__*/React__default["default"].cloneElement(c, c.props));
  })));
});

var _templateObject$5, _templateObject2$4, _templateObject3$2, _templateObject4, _templateObject5;
var Container$3 = styled__default["default"](Box)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  background-color: ", ";\n  @media (min-width: 769px) {\n    padding-top: 100px;\n    padding-bottom: 100px;\n    background-image: url(/journeyline-whats-new.svg);\n    background-repeat: no-repeat;\n    background-position: 140px 0;\n  }\n\n  @media (max-width: 768px) {\n    padding: 12px;\n  }\n"])), grey800);
var CardRow = styled__default["default"](Box)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-start;\n\n  height: 669px;\n\n  padding-left: 48px;\n  padding-right: 48px;\n\n  @media (max-width: 1024px) {\n    height: 480px;\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n\n  @media (max-width: 768px) {\n    height: fit-content;\n    flex-wrap: nowrap;\n    padding: 0;\n  }\n"])));
var Right = styled__default["default"](Box)(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n  align-self: flex-end;\n\n  margin-bottom: 50px;\n  margin-right: 24px;\n"])));
var CardContainer = styled__default["default"](Box)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: calc(100% - 96px - 669px);\n  height: 200px;\n\n  @media (max-width: 1024px) {\n    width: calc(100% - 48px - 480px);\n    height: 145px;\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n    height: fit-content;\n    margin-bottom: 20px;\n  }\n"])));
var ImageContainer = styled__default["default"](Box)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 669px;\n  height: 669px;\n\n  @media (max-width: 1024px) {\n    width: 480px;\n    height: 480px;\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n    height: 268px;\n    margin-bottom: 40px;\n  }\n"])));
var WhatsNewSection = (function (_ref) {
  var header = _ref.header,
    children = _ref.children;
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints);
    _useBreakpoint.breakpoint;
  return /*#__PURE__*/React__default["default"].createElement(Container$3, null, /*#__PURE__*/React__default["default"].createElement(Right, null, header), /*#__PURE__*/React__default["default"].createElement(CardRow, null, React__default["default"].Children.map(children, function (c, index) {
    return index === 0 ? /*#__PURE__*/React__default["default"].createElement(ImageContainer, null, /*#__PURE__*/React__default["default"].cloneElement(c, _objectSpread2({}, c.props))) : /*#__PURE__*/React__default["default"].createElement(CardContainer, null, /*#__PURE__*/React__default["default"].cloneElement(c, _objectSpread2(_objectSpread2({}, c.props), {}, {
      variant: 'horizontal'
    })));
  })));
});

var MenuContext = /*#__PURE__*/React$1.createContext({});
var Context = (function (_ref) {
  var actions = _ref.actions,
    links = _ref.links,
    labels = _ref.labels,
    eyebrow = _ref.eyebrow,
    navigation = _ref.navigation,
    language = _ref.language,
    children = _ref.children;
  var _useState = React$1.useState(language),
    _useState2 = _slicedToArray(_useState, 2),
    currentLanguage = _useState2[0],
    setCurrentLanguage = _useState2[1];
  var navigate = actions.navigate,
    onLanguageChange = actions.onLanguageChange,
    search = actions.search;
  var followLink = function followLink(slug, callback) {
    return function () {
      if (callback) {
        callback();
      }
      navigate(slug);
    };
  };
  var changeLanguage = function changeLanguage(lang) {
    setCurrentLanguage(lang);
    onLanguageChange(lang);
  };
  return /*#__PURE__*/React__default["default"].createElement(MenuContext.Provider, {
    value: {
      actions: {
        followLink: followLink,
        changeLanguage: changeLanguage,
        search: search
      },
      eyebrow: eyebrow,
      navigation: navigation,
      labels: labels,
      links: links,
      language: currentLanguage
    }
  }, children);
});

var Hours = (function (_ref) {
  var dark = _ref.dark;
  var _useContext = React$1.useContext(MenuContext),
    _useContext$labels = _useContext.labels,
    hoursLabel = _useContext$labels.hoursLabel,
    hours = _useContext$labels.hours;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, null, /*#__PURE__*/React__default["default"].createElement(Box, {
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    bold: true,
    color: dark ? white : grey400
  }, "".concat(hoursLabel, ": "))), /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    color: dark ? white : grey400
  }, hours));
});

var LanguageToggle = (function (_ref) {
  var dark = _ref.dark;
  var _useContext = React$1.useContext(MenuContext),
    language = _useContext.language;
  var _useContext2 = React$1.useContext(MenuContext),
    changeLanguage = _useContext2.actions.changeLanguage;
  var handleSelect = function handleSelect(val) {
    return function () {
      changeLanguage(val);
    };
  };
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, null, /*#__PURE__*/React__default["default"].createElement(Box, {
    mr: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    compact: true,
    label: "En",
    dark: dark,
    variant: "text",
    bold: language === 'en',
    onClick: handleSelect('en')
  })), /*#__PURE__*/React__default["default"].createElement(Body, {
    variant: "small",
    color: dark ? white : grey400
  }, "|"), /*#__PURE__*/React__default["default"].createElement(Box, {
    ml: "10px"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    compact: true,
    label: "Es",
    dark: dark,
    variant: "text",
    bold: language === 'es',
    onClick: handleSelect('es')
  })));
});

var _templateObject$4, _templateObject2$3;
var Container$2 = styled__default["default"](FlexBox)(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  flex-wrap: wrap;\n  width: 100%;\n  background-color: ", ";\n  padding: 24px 12px;\n"])), grey800);
var SubMenu = styled__default["default"](FlexBox)(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  width: 45%;\n  margin-bottom: 12px;\n"])));
var MobileSubnav = (function (_ref) {
  var sections = _ref.sections,
    close = _ref.close;
  var _useContext = React$1.useContext(MenuContext),
    followLink = _useContext.actions.followLink;
  return /*#__PURE__*/React__default["default"].createElement(Container$2, {
    justifyContent: "space-between"
  }, sections.map(function (section) {
    return /*#__PURE__*/React__default["default"].createElement(SubMenu, {
      flexDirection: "column"
    }, /*#__PURE__*/React__default["default"].createElement(H6, {
      variant: "condensed",
      onClick: followLink(section.slug, close)
    }, section.label), section.links.map(function (_ref2) {
      var slug = _ref2.slug,
        label = _ref2.label;
      return /*#__PURE__*/React__default["default"].createElement(Box, {
        mb: "10px"
      }, /*#__PURE__*/React__default["default"].createElement(Button, {
        key: slug,
        variant: "text",
        onClick: followLink(slug, close),
        label: label
      }));
    }));
  }));
});

var MobileLinks = (function (_ref) {
  var close = _ref.close;
  var _useContext = React$1.useContext(MenuContext),
    _useContext$links = _useContext.links,
    blogLink = _useContext$links.blog,
    shopLink = _useContext$links.shop,
    subscribeLink = _useContext$links.subscribe,
    _useContext$labels = _useContext.labels,
    blogLabel = _useContext$labels.blog,
    shopLabel = _useContext$labels.shop,
    subscribeLabel = _useContext$labels.subscribe,
    followLink = _useContext.actions.followLink;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    padding: "12px 24px",
    justifyContent: "space-between"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "text",
    dark: true,
    label: shopLabel,
    onClick: followLink(shopLink, close)
  }), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "text",
    dark: true,
    label: subscribeLabel,
    onClick: followLink(subscribeLink, close)
  }), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "text",
    dark: true,
    label: blogLabel,
    onClick: followLink(blogLink, close)
  }));
});

var EyebrowTop = (function (_ref) {
  var mobile = _ref.mobile;
  var _useState = React$1.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var _useContext = React$1.useContext(MenuContext),
    eyebrow = _useContext.eyebrow,
    followLink = _useContext.actions.followLink;
  React$1.useEffect(function () {
    var interval = setInterval(function () {
      setIndex(function (index) {
        return index + 1;
      });
    }, 5000);
    return function () {
      return clearInterval(interval);
    };
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, eyebrow.length != 0 && /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: mobile ? "center" : "flex-end"
  }, /*#__PURE__*/React__default["default"].createElement(Box, {
    mr: mobile ? '' : "20px",
    key: index
  }, /*#__PURE__*/React__default["default"].createElement(Eyebrow, {
    body: eyebrow[index % eyebrow.length].body,
    link: eyebrow[index % eyebrow.length].link,
    linktext: eyebrow[index % eyebrow.length].linktext,
    theme: eyebrow[index % eyebrow.length].theme,
    navigate: followLink
  }))));
});

var _templateObject$3, _templateObject2$2, _templateObject3$1;
styled__default["default"](FlexBox)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  padding: 0 12px;\n"])));
var CloseButton = styled__default["default"](Box)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  transform: rotate(45deg);\n  background-color: white;\n  mask-image: url(/accordion-caret.svg);\n  mask-repeat: no-repeat;\n  mask-size: contain;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n"])));
var Divider = styled__default["default"](Box)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  margin: 12px;\n  border-bottom: 2px solid white;\n"])));
var MobileMenu = (function () {
  var _useState = React$1.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var toggleOpen = function toggleOpen() {
    return setOpen(!open);
  };
  var _useContext = React$1.useContext(MenuContext),
    followLink = _useContext.actions.followLink,
    _useContext$labels = _useContext.labels,
    membershipLabel = _useContext$labels.membership,
    socialLabel = _useContext$labels.social,
    membershipLink = _useContext.links.membership,
    eyebrow = _useContext.eyebrow,
    navigation = _useContext.navigation;
  var _useContext2 = React$1.useContext(SearchContext),
    searchOpen = _useContext2.open;
  return open ? /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column",
    backgroundColor: purple,
    minHeight: "100vh"
  }, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    mb: "20px",
    padding: "12px 24px 12px 12px",
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Logo, {
    width: "149px",
    height: "100px",
    dark: true
  }), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "flex-end",
    alignItems: "baseline"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "magnifying-glass",
    dark: true,
    color: purple,
    onClick: searchOpen
  }), /*#__PURE__*/React__default["default"].createElement(CloseButton, {
    onClick: toggleOpen
  }))), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Hours, {
    dark: true
  })), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "center",
    width: "100%",
    mt: "12px"
  }, /*#__PURE__*/React__default["default"].createElement(Box, {
    mr: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(LanguageToggle, {
    dark: true
  })), eyebrow.map(function (link) {
    return /*#__PURE__*/React__default["default"].createElement(Button, {
      bold: true,
      variant: "text",
      key: link.slug,
      dark: true,
      label: link.label,
      onClick: followLink(link.slug, toggleOpen)
    });
  })), /*#__PURE__*/React__default["default"].createElement(Divider, null), navigation.map(function (section) {
    return /*#__PURE__*/React__default["default"].createElement(AccordionItem, {
      variant: "mobile-menu",
      key: section.slug,
      title: section.label,
      onClick: followLink(section.slug, toggleOpen),
      dark: true,
      color: white
    }, /*#__PURE__*/React__default["default"].createElement(MobileSubnav, {
      sections: section.sections,
      close: toggleOpen
    }));
  }), /*#__PURE__*/React__default["default"].createElement(Divider, null), /*#__PURE__*/React__default["default"].createElement(MobileLinks, {
    close: toggleOpen
  }), /*#__PURE__*/React__default["default"].createElement(Divider, null), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    padding: "0 24px",
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(H5, {
    dark: true,
    margin: "10px 0"
  }, socialLabel), /*#__PURE__*/React__default["default"].createElement(SocialButtons, {
    dark: true
  })), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "center",
    padding: "24px"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    dark: true,
    liquid: true,
    variant: "outline",
    label: membershipLabel,
    onClick: followLink(membershipLink, toggleOpen)
  }))) : /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px"
  }, /*#__PURE__*/React__default["default"].createElement(Logo, {
    width: "149px",
    height: "100px",
    onClick: followLink('/')
  }), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "flex-end",
    alignItems: "baseline"
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "magnifying-glass",
    color: grey400,
    onClick: searchOpen
  }), /*#__PURE__*/React__default["default"].createElement(Button, {
    color: grey400,
    variant: "icon",
    icon: "hamburger",
    onClick: toggleOpen
  }))), /*#__PURE__*/React__default["default"].createElement(EyebrowTop, {
    mobile: true
  }));
});

var NavigationTop = (function () {
  var _useContext = React$1.useContext(SearchContext),
    open = _useContext.open;
  return /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "flex-end",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Box, {
    mr: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(Hours, null)), /*#__PURE__*/React__default["default"].createElement(Box, {
    mr: "20px"
  }, /*#__PURE__*/React__default["default"].createElement(LanguageToggle, null)), /*#__PURE__*/React__default["default"].createElement(Button, {
    variant: "icon",
    icon: "magnifying-glass",
    color: grey400,
    onClick: open
  }));
});

var _templateObject$2, _templateObject2$1, _templateObject3;
var Container$1 = styled__default["default"](FlexBox)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  width: 105vw;\n  background-color: ", ";\n  justify-content: center;\n  align-items: flex-start;\n  position: absolute;\n  top: 32px;\n  left: ", ";\n  background-opacity: .6;\n  padding: 48px;\n  z-index: 1000;\n"])), purple, function (props) {
  return "-".concat(props.offset + 1, "px");
});
var Section = styled__default["default"](FlexBox)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  width: 18%;\n  margin-right: 48px;\n"])));
var SectionLink = styled__default["default"](H5)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
var SectionSubnav = (function (_ref) {
  var sections = _ref.sections,
    offset = _ref.offset,
    close = _ref.close;
  var _useContext = React$1.useContext(MenuContext),
    followLink = _useContext.actions.followLink;
  return /*#__PURE__*/React__default["default"].createElement(Container$1, {
    offset: offset
  }, sections.map(function (section, sIndex) {
    return /*#__PURE__*/React__default["default"].createElement(Section, {
      key: sIndex
    }, /*#__PURE__*/React__default["default"].createElement(SectionLink, {
      color: white,
      margin: "10px 0",
      onClick: followLink(section.slug, close)
    }, section.label), section.links.map(function (link, lIndex) {
      return /*#__PURE__*/React__default["default"].createElement(Box, {
        mb: "12px",
        key: lIndex
      }, /*#__PURE__*/React__default["default"].createElement(Button, {
        dark: true,
        color: white,
        variant: "text",
        label: link.label,
        onClick: followLink(link.slug, close)
      }));
    }));
  }));
});

var _templateObject$1, _templateObject2;
var Container = styled__default["default"](FlexBox)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var NavLink = styled__default["default"](Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  margin-right: 18px;\n  margin-bottom: -31px;\n  & :last-child {\n    margin-right: 0;\n  }\n"])));
var Subsection = (function (_ref) {
  var label = _ref.label,
    slug = _ref.slug,
    sections = _ref.sections,
    open = _ref.open,
    handleMouseOver = _ref.handleMouseOver,
    handleMouseOut = _ref.handleMouseOut;
  var _useContext = React$1.useContext(MenuContext),
    followLink = _useContext.actions.followLink;
  var linkRef = React$1.useRef();
  return /*#__PURE__*/React__default["default"].createElement(Container, {
    ref: linkRef,
    flexDirection: "column",
    onMouseEnter: handleMouseOver,
    onMouseLeave: handleMouseOut
  }, /*#__PURE__*/React__default["default"].createElement(NavLink, {
    onClick: followLink(slug, handleMouseOut)
  }, /*#__PURE__*/React__default["default"].createElement(H4, {
    color: open ? purple : grey400,
    variant: "condensed",
    textTransform: "uppercase",
    margin: "5px 0",
    style: open ? {
      textDecoration: 'underline'
    } : {
      textDecoration: 'none'
    }
  }, label)), open && /*#__PURE__*/React__default["default"].createElement(SectionSubnav, {
    sections: sections,
    offset: linkRef.current.offsetLeft,
    close: handleMouseOut
  }));
});

var _templateObject;
var HeaderContainer = styled__default["default"](FlexBox)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: white;\n  width: 100%;\n  @media (min-width: 1025px) {\n    margin-top: 10px;\n    padding: 0 48px;\n  } \n  @media (max-width: 1024px) {\n    margin-top: 10px;\n    padding: 0 24px;\n  } \n  z-index: 999;\n"])));
var DesktopMenu = (function () {
  var _useState = React$1.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeSection = _useState2[0],
    setActiveSection = _useState2[1];
  var _useContext = React$1.useContext(MenuContext),
    navigation = _useContext.navigation,
    followLink = _useContext.actions.followLink;
  var handleMouseOver = function handleMouseOver(label) {
    return function () {
      return setActiveSection(label);
    };
  };
  var handleMouseOut = function handleMouseOut() {
    return setActiveSection(null);
  };
  return /*#__PURE__*/React__default["default"].createElement(Box, null, /*#__PURE__*/React__default["default"].createElement(HeaderContainer, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Logo, {
    width: "187px",
    height: "126px",
    onClick: followLink('/')
  }), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    flexDirection: "column"
  }, /*#__PURE__*/React__default["default"].createElement(EyebrowTop, null), /*#__PURE__*/React__default["default"].createElement(NavigationTop, null), /*#__PURE__*/React__default["default"].createElement(FlexBox, {
    justifyContent: "flex-end",
    alignItems: "center"
  }, navigation.map(function (section) {
    return /*#__PURE__*/React__default["default"].createElement(Subsection, _extends({
      key: section.slug
    }, section, {
      open: activeSection === section.label,
      handleMouseOver: handleMouseOver(section.label),
      handleMouseOut: handleMouseOut
    }));
  })))));
});

var Menu = (function () {
  var _useBreakpoint = useBreakpoint__default["default"](breakpoints),
    breakpoint = _useBreakpoint.breakpoint;
  return breakpoint === 'mobile' ? /*#__PURE__*/React__default["default"].createElement(MobileMenu, null) : /*#__PURE__*/React__default["default"].createElement(DesktopMenu, null);
});

exports.Accordion = Accordion;
exports.AccordionItem = AccordionItem;
exports.Alert = Alert;
exports.ArticleQuote = ArticleQuote;
exports.Body = Body;
exports.Box = Box;
exports.Breadcrumbs = Breadcrumbs;
exports.Button = Button;
exports.ButtonInput = ButtonInput;
exports.Caption = Caption;
exports.Card = Card$1;
exports.CarouselItem = CarouselItem;
exports.CollectionCarousel = CollectionCarousel;
exports.CollectionConstituent = CollectionConstituent;
exports.CollectionFilters = CollectionFilters;
exports.CollectionFooter = CollectionFooter;
exports.CollectionItemDescription = CollectionItemDescription;
exports.CollectionItemHeader = CollectionItemHeader;
exports.CollectionsSection = CollectionsSection;
exports.ContactSidebarSection = ContactSidebarSection;
exports.Container = Container$C;
exports.ContentBlock = ContentBlock;
exports.DMALogo = Logo;
exports.DateFilter = DateFilter;
exports.DateRangeFilter = DateRangeFilter;
exports.DetailSidebarSection = DetailSidebarSection;
exports.Divider = Divider$1;
exports.EventFilters = EventFilters;
exports.EventsSection = EventsSection;
exports.ExhibitionFilters = ExhibitionFilters;
exports.ExhibitionsSection = ExhibitionsSection;
exports.Eyebrow = Eyebrow;
exports.Filter = Filter;
exports.FilterBar = FilterBar;
exports.FilterBase = Filter$1;
exports.FlexBox = FlexBox;
exports.Footer = Footer;
exports.H1 = H1;
exports.H2 = H2;
exports.H3 = H3;
exports.H4 = H4;
exports.H5 = H5;
exports.H6 = H6;
exports.Hero = JourneylineHero;
exports.HeroActionBox = HeroActionBox;
exports.HeroCarousel = HeroCarousel;
exports.HeroHeader = HeroHeader;
exports.HeroStack = HeroStack;
exports.HomepageHero = HomepageHero;
exports.HomepageSectionHeader = HomepageSectionHeader;
exports.Icon = Icon;
exports.Image = Image$1;
exports.JourneylineCalloutSection = JourneylineCalloutSection;
exports.JourneylineHeader = JourneylineHeader;
exports.JourneylineSection = JourneylineSection;
exports.Loading = Loading;
exports.Menu = Menu;
exports.MenuButton = MenuButton;
exports.MenuContext = Context;
exports.PageHeadline = PageHeadline;
exports.Pagination = Pagination;
exports.PressFilters = PressFilters;
exports.PressInquiriesSection = PressInquiriesSection;
exports.PriceCard = Card;
exports.QuoteBoxHero = QuoteBoxHero;
exports.QuoteBoxImage = QuoteBoxImage;
exports.QuotedImageSection = QuotedImageSection;
exports.RangeFilter = RangeFilter;
exports.ResourceLink = ResourceLink;
exports.SearchContext = SearchContext$1;
exports.SearchResultsGrid = SearchResultsGrid;
exports.SharingSidebarSection = SharingSidebarSection;
exports.ShopSection = ShopSection;
exports.SimpleCarousel = SimpleCarousel;
exports.SiteSearch = SiteSearch;
exports.SiteSearchResult = SiteSearchResult;
exports.SlideShow = Slideshow;
exports.SocialButtons = SocialButtons;
exports.SocialShare = SocialShare;
exports.Tag = Tag$1;
exports.ThreeColumn = ThreeColumn;
exports.TwoColumn = TwoColumn;
exports.VideoHero = VideoHero;
exports.VideoPlayer = VideoPlayer;
exports.WhatsNewSection = WhatsNewSection;
exports.black = black;
exports.breakpoints = breakpoints;
exports.darkTeal = darkTeal;
exports.green = green;
exports.grey100 = grey100;
exports.grey200 = grey200;
exports.grey300 = grey300;
exports.grey400 = grey400;
exports.grey500 = grey500;
exports.grey600 = grey600;
exports.grey700 = grey700;
exports.grey800 = grey800;
exports.limeGreen = limeGreen;
exports.magenta = magenta;
exports.purple = purple;
exports.red = red;
exports.teal = teal;
exports.white = white;
//# sourceMappingURL=bundle.js.map
